(function () {
    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['tanker'] = i18n['tanker'] || {};

    i18n['tanker']['dynamic'] = {
        gender: function (params) {
            return (function (params) {
                return params[params.gender];
            })(params);
        },
        plural: function (params) {
            return (function (params) {
                var count = isNaN(parseInt(params.count)) ? 0 : params.count,
                    lastNumber = count % 10,
                    lastNumbers = count % 100;

                return lastNumber == 1 && lastNumbers != 11
                    ? params.one
                    : lastNumber > 1 && lastNumber < 5 && (lastNumbers < 10 || lastNumbers > 20)
                      ? params.some
                      : params.many;
            })(params);
        },
        plural_adv: function (params) {
            return (function (params) {
                var count = isNaN(parseInt(params.count)) ? 0 : params.count;

                if (count === 0) {
                    return params.none;
                }

                return i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: params['one'],
                    some: params['some'],
                    many: params['many'],
                });
            })(params);
        },
        toggle: function (params) {
            return (function (params) {
                return Boolean(params.condition) ? params['true'] : params['false'];
            })(params);
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['broadcast-view'] = {
        'broadcast-start-countdown': function (params) {
            return 'Трансляция начнётся через';
        },
        'broadcast-start-countdown-ended': function (params) {
            return 'Организатор скоро начнёт трансляцию';
        },
        'broadcast-start-date': function (params) {
            return params['date'] + ' в ' + params['time'];
        },
        'broadcast-start-date-title': function (params) {
            return 'Трансляция начнётся';
        },
        'broadcast-stopped': function (params) {
            return 'Трансляция приостановлена. Организатор скоро продолжит трансляцию';
        },
        'created-by': function (params) {
            return 'Организатор: ' + params['name'];
        },
        'started-at': function (params) {
            return 'Трансляция началась в ' + params['time'];
        },
        'viewers-count': function (params) {
            return 'Сейчас смотрят ' + params['count'];
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['call'] = {
        'additional-number-template': function (params) {
            return 'Доб. ' + params['number'];
        },
        'broadcast-link': function (params) {
            return 'Ссылка на трансляцию';
        },
        'call-connecting': function (params) {
            return 'Соединение';
        },
        'call-into-meeting': function (params) {
            return 'Позвонить во встречу';
        },
        'copy-invitation': function (params) {
            return 'Скопировать приглашение';
        },
        'invitation-copied': function (params) {
            return 'Приглашение скопировано';
        },
        'invitation-header': function (params) {
            return 'Встреча в Яндекс Телемосте';
        },
        'invite-participants': function (params) {
            return 'Пригласить участников';
        },
        link: function (params) {
            return 'Ссылка на видеовстречу';
        },
        'link-copied': function (params) {
            return 'Ссылка скопирована';
        },
        'link-copied-on-start': function (params) {
            return 'Ссылка на встречу скопирована';
        },
        'link-successfully-copied': function (params) {
            return 'Ссылка скопирована';
        },
        'meeting-link': function (params) {
            return 'Ссылка на встречу';
        },
        'network-quality-status-bad-another': function (params) {
            return 'У этого участника плохая связь';
        },
        'network-quality-status-bad-self': function (params) {
            return 'У вас плохая связь';
        },
        'outgoing-call': function (params) {
            return 'Исходящий звонок';
        },
        'participant-video-limited': function (params) {
            return 'На этого пользователя\nдействуют ограничения\nвидео';
        },
        'participants-count': function (params) {
            return (
                'На встрече ' +
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'человек',
                    some: 'человека',
                    many: 'человек',
                })
            );
        },
        'participants-list': function (params) {
            return 'Список участников';
        },
        'phone-invitation-header': function (params) {
            return 'Позвонить во встречу в Яндекс Телемосте';
        },
        'phone-number-copied': function (params) {
            return 'Номер скопирован';
        },
        'phone-template': function (params) {
            return params['phone'] + ', доб. ' + params['number'];
        },
        'share-link-copy-button': function (params) {
            return 'Копировать ссылку ещё раз';
        },
        'share-link-copy-button-on-blur': function (params) {
            return 'Скопировать ссылку';
        },
        'share-link-copy-button-success': function (params) {
            return 'Ссылка уже скопирована';
        },
        'share-link-meeting-number': function (params) {
            return 'Встреча № ' + params['number'];
        },
        'share-link-messenger': function (params) {
            return 'Отправить в Yandex Messenger';
        },
        'share-link-slack': function (params) {
            return 'Отправить в Slack';
        },
        'share-link-tg': function (params) {
            return 'Отправить в Telegram';
        },
        'share-link-title': function (params) {
            return 'Чтобы пригласить других участников,\nотправьте им ссылку на встречу';
        },
        'share-link-whatsapp': function (params) {
            return 'Отправить в WhatsApp';
        },
        'sso-account-suggest': function (params) {
            return 'Если есть рабочий аккаунт, лучше подключиться с ним';
        },
        'telemessenger-link-copied': function (params) {
            return 'Ссылка на звонок скопирована';
        },
        'video-limited-reason-network': function (params) {
            return 'Видео нет из-за плохой связи';
        },
        'video-limited-reason-room-size': function (params) {
            return 'Видео появится, когда участник заговорит';
        },
        'video-limited-reason-self': function (params) {
            return 'Вы скрыли видео участников';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['chats'] = {
        broadcast_description: function (params) {
            return 'Время указано в часовом поясе организатора. Чат можно переименовать. [Ссылка для зрителей](%broadcast-uri%)';
        },
        broadcast_system_message: function (params) {
            return 'Это общий чат для зрителей и организаторов. Чтобы поделиться трансляцией, отправьте [эту ссылку](%broadcast-uri%)';
        },
        broadcast_title: function (params) {
            return 'Трансляция в Телемосте (чат создан %date%)';
        },
        noname_title: function (params) {
            return 'Трансляция в Телемосте';
        },
        nonpermanent_description: function (params) {
            return 'Начало встречи указано в часовом поясе организатора, [ссылка на видеовстречу](%conference-uri%).';
        },
        nonpermanent_title: function (params) {
            return 'Встреча в Телемосте %date%';
        },
        permanent_description: function (params) {
            return 'Время указано в часовом поясе организатора. Чат можно переименовать. [Ссылка на видеовстречу](%conference-uri%).';
        },
        permanent_title: function (params) {
            return 'Встреча в Телемосте (чат создан %date%)';
        },
        system_message: function (params) {
            return 'Чат сохранится в Яндекс Мессенджере, если вы авторизованы на Яндексе.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['cloud-recording'] = {
        'stop-modal-cancel': function (params) {
            return 'Нет';
        },
        'stop-modal-confirm': function (params) {
            return 'Да';
        },
        'stop-modal-description': function (params) {
            return 'Запись остановится у всех. Ссылка появится в чате и на почте организатора, но не сразу — обработка займёт время';
        },
        'stop-modal-header': function (params) {
            return 'Остановить запись на Яндекс Диск?';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['common'] = {
        admit: function (params) {
            return 'Впустить';
        },
        'admit-all': function (params) {
            return 'Впустить всех';
        },
        'admit-to-limit': function (params) {
            return 'Впустить до лимита';
        },
        back: function (params) {
            return 'Назад';
        },
        cancel: function (params) {
            return 'Отменить';
        },
        'change-account': function (params) {
            return 'Сменить аккаунт';
        },
        'close-dialog': function (params) {
            return 'Закрыть окно';
        },
        continue: function (params) {
            return 'Продолжить';
        },
        'continue-in-browser': function (params) {
            return 'Продолжить в браузере';
        },
        'copy-link': function (params) {
            return 'Копировать ссылку';
        },
        'copy-link-action': function (params) {
            return 'Скопировать ссылку';
        },
        'copy-link-short': function (params) {
            return 'Скопировать';
        },
        'copy-link-to-conf': function (params) {
            return 'Скопировать ссылку на встречу';
        },
        'got-it': function (params) {
            return ' Понятно';
        },
        guest: function (params) {
            return 'Гость';
        },
        install: function (params) {
            return 'Установить';
        },
        'install-app': function (params) {
            return 'Установить программу';
        },
        'install-app-v2': function (params) {
            return 'Программа для компьютера';
        },
        'install-app-v3': function (params) {
            return 'Телемост для ' + params['osFamily'];
        },
        'install-app-v4': function (params) {
            return 'Скачать на ' + params['osFamily'];
        },
        'install-mobile-app': function (params) {
            return 'Мобильное приложение';
        },
        'install-mobile-app-message': function (params) {
            return 'Скачать мобильное приложение';
        },
        'install-mobile-app-v2': function (params) {
            return 'Телемост для телефона';
        },
        'install-mobile-app-v3': function (params) {
            return 'Скачать на телефон';
        },
        login: function (params) {
            return 'Войти';
        },
        logout: function (params) {
            return 'Выйти';
        },
        name: function (params) {
            return 'Имя';
        },
        'not-now': function (params) {
            return 'Не сейчас';
        },
        ok: function (params) {
            return 'Хорошо';
        },
        'open-in-app': function (params) {
            return 'Открыть в приложении';
        },
        'organizer-revoked-admit-permission': function (params) {
            return 'Организатор запретил впускать участников';
        },
        retry: function (params) {
            return 'Попробовать ещё';
        },
        'retry-one-more-time': function (params) {
            return 'Попробовать ещё раз';
        },
        'share-button-text': function (params) {
            return 'Пригласить на встречу';
        },
        'share-tooltip-text': function (params) {
            return 'Пригласить людей на встречу';
        },
        support: function (params) {
            return 'Поддержка';
        },
        'to-home': function (params) {
            return 'На главную';
        },
        'to-home-screen': function (params) {
            return 'На главный экран';
        },
        'try-app': function (params) {
            return 'Попробовать';
        },
        unwrap: function (params) {
            return 'Развернуть';
        },
        view: function (params) {
            return 'Посмотреть';
        },
        wrap: function (params) {
            return 'Свернуть';
        },
        'yandex-disk-title': function (params) {
            return 'Яндекс Диск';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['conferences-history'] = {
        'access-forbidden-contact-owner': function (params) {
            return 'Недоступна. Обратитесь к организаторам встречи';
        },
        'access-forbidden-contact-support': function (params) {
            return 'Недоступна';
        },
        admins: function (params) {
            return 'Соорганизаторы';
        },
        'all-confs': function (params) {
            return 'Все встречи';
        },
        'batch-fetching-failed': function (params) {
            return 'Не загрузилась часть встреч. Попробуйте обновить';
        },
        'change-filters-hint': function (params) {
            return 'Попробуйте настроить фильтры иначе';
        },
        'cloud-recording': function (params) {
            return 'Запись на Яндекс Диск';
        },
        'conf-number': function (params) {
            return 'Номер встречи';
        },
        'conference-number': function (params) {
            return 'Встреча № ' + params['id'];
        },
        'conferences-history': function (params) {
            return 'История встреч';
        },
        'contact-support': function (params) {
            return 'Написать в поддержку';
        },
        'copy-email': function (params) {
            return 'Скопировать почту';
        },
        day: function (params) {
            return 'За день';
        },
        'email-copied': function (params) {
            return 'Почта скопирована\n';
        },
        'empty-result-title': function (params) {
            return 'Здесь будут прошедшие встречи';
        },
        'empty-result-title-active-filter': function (params) {
            return 'Такой встречи нет';
        },
        'fetching-error': function (params) {
            return 'Список встреч не загрузился';
        },
        filter: function (params) {
            return 'Фильтр';
        },
        'for-3-month': function (params) {
            return 'За 3 месяца';
        },
        home: function (params) {
            return 'На главную';
        },
        'in-progress': function (params) {
            return 'Обрабатывается';
        },
        'in-your-mail': function (params) {
            return 'У вас на почте';
        },
        'insufficient-disk-space': function (params) {
            return 'Не удаётся загрузить запись - не хватает места на вашем диске';
        },
        'local-recording': function (params) {
            return 'Запись на компьютер';
        },
        'meeting-report': function (params) {
            return 'Отчёт по участию';
        },
        members: function (params) {
            return 'Участники';
        },
        'members-recording': function (params) {
            return 'Записывали участники';
        },
        month: function (params) {
            return 'За месяц';
        },
        'no-artifacts': function (params) {
            return 'Без материалов';
        },
        other: function (params) {
            return 'Не создалась из-за технического сбоя';
        },
        'other-summarization': function (params) {
            return 'Не создался из-за технического сбоя';
        },
        owner: function (params) {
            return 'Организатор';
        },
        period: function (params) {
            return 'За период';
        },
        recording: function (params) {
            return 'Запись';
        },
        'recording-too-short': function (params) {
            return 'Не создалась. Запись шла меньше 15 секунд';
        },
        refresh: function (params) {
            return 'Обновить';
        },
        'report-error': function (params) {
            return 'Отчёт не создался из-за технического сбоя';
        },
        'report-error-common': function (params) {
            return 'Отчёт недоступен';
        },
        reset: function (params) {
            return 'Сбросить';
        },
        'reset-all': function (params) {
            return 'Сбросить всё';
        },
        'reset-filters': function (params) {
            return 'Сбросить фильтры';
        },
        'select-conference': function (params) {
            return 'Выберите встречу, чтобы посмотреть детали';
        },
        'send-to-email': function (params) {
            return 'Отправлен вам на почту';
        },
        'show-more-recipients': function (params) {
            return 'Показать ещё ' + params['count'] + ' участников';
        },
        summarization: function (params) {
            return 'Конспект';
        },
        'summarization-too-short': function (params) {
            return 'Не создался. Возможно, конспектирование шло меньше 30 секунд, или все участники молчали ';
        },
        today: function (params) {
            return 'сегодня';
        },
        watch: function (params) {
            return 'Смотреть';
        },
        'who-receive': function (params) {
            return 'Кто получил';
        },
        'who-recording': function (params) {
            return 'Кто записывал';
        },
        'with-recording': function (params) {
            return 'С записью';
        },
        'with-report': function (params) {
            return 'С отчётом по участию';
        },
        'with-summary': function (params) {
            return 'С конспектом';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['create-broadcast'] = {
        'access-level-organization': function (params) {
            return 'Для сотрудников';
        },
        'access-level-public': function (params) {
            return 'Для всех';
        },
        'broadcast-title-tooltip': function (params) {
            return 'Название увидят участники и зрители трансляции';
        },
        'caption-placeholder': function (params) {
            return 'Название';
        },
        'caption-placeholder-v2': function (params) {
            return 'Название — его увидят зрители';
        },
        'description-placeholder': function (params) {
            return 'Описание';
        },
        'form-title': function (params) {
            return 'Новая трансляция';
        },
        'start-button': function (params) {
            return 'Создать трансляцию сейчас';
        },
        'start-button-short': function (params) {
            return 'Создать сейчас';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['create-call'] = {
        'app-description': function (params) {
            return 'Создайте видеовстречу\nи отправьте ссылку на встречу\nдрузьям или коллегам.';
        },
        'broadcast-description': function (params) {
            return 'Для зрителей отдельная ссылка, \nв видеовстрече только участники';
        },
        'broadcast-text': function (params) {
            return 'Новая трансляция';
        },
        connect: function (params) {
            return 'Подключиться';
        },
        'connect-call-description': function (params) {
            return 'По ссылке или\nномеру встречи';
        },
        'connect-call-text': function (params) {
            return 'Подключиться';
        },
        'create-call-text': function (params) {
            return 'Создать видеовстречу';
        },
        'disabled-broadcast-description': function (params) {
            return 'Недоступно на вашем тарифе';
        },
        'disabled-broadcast-description-more': function (params) {
            return 'Подробнее';
        },
        'insert-link-or-meeting-number': function (params) {
            return 'Укажите номер встречи или вставьте ссылку';
        },
        'insert-link-or-meeting-number-notification': function (params) {
            return 'Введите номер встречи или вставьте ссылку на встречу';
        },
        'install-button-tooltip': function (params) {
            return 'В программе еще удобнее';
        },
        'main-title': function (params) {
            return 'Яндекс Телемост — видеовстречи по ссылке';
        },
        'main-title-v2': function (params) {
            return 'Яндекс Телемост —\nчаты и видеозвонки';
        },
        'new-call-description': function (params) {
            return 'Начнется прямо сейчас, отправьте ссылку участникам';
        },
        'new-call-text': function (params) {
            return 'Новая видеовстреча';
        },
        ok: function (params) {
            return 'Хорошо';
        },
        'plan-call-description': function (params) {
            return 'В Календаре создастся событие со ссылкой на видеовстречу';
        },
        'plan-call-text': function (params) {
            return 'Запланировать';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['dtmf'] = {
        'command-list.audio.mute': function (params) {
            return 'Выключить микрофон';
        },
        'command-list.audio.unmute': function (params) {
            return 'Включить микрофон';
        },
        'command-list.gallery-view.turn-on': function (params) {
            return 'Включить вид галереи';
        },
        'command-list.participant-list.open': function (params) {
            return 'Список участников';
        },
        'command-list.participant-list.show': function (params) {
            return 'Показать список участников';
        },
        'command-list.presenter-view.turn-on': function (params) {
            return 'Включить вид докладчика';
        },
        'command-list.reactions.hand-down': function (params) {
            return 'Опустить руку';
        },
        'command-list.reactions.hand-up': function (params) {
            return 'Поднять руку';
        },
        'command-list.subtitle': function (params) {
            return 'Нажмите нужный символ на клавиатуре планшета';
        },
        'command-list.title': function (params) {
            return 'Список команд';
        },
        'command-list.video.mute': function (params) {
            return 'Выключить камеру';
        },
        'command-list.video.unmute': function (params) {
            return 'Включить камеру';
        },
        'common.close': function (params) {
            return 'Закрыть';
        },
        'gallery-view': function (params) {
            return 'Вид галереи';
        },
        'notification.camera-and-microphone-muted': function (params) {
            return 'Камера и микрофон выключены.';
        },
        'notification.camera-muted': function (params) {
            return 'Камера выключена.';
        },
        'notification.hand-lower': function (params) {
            return 'Опустить';
        },
        'notification.hand-raised': function (params) {
            return 'Рука поднята.';
        },
        'notification.microphone-muted': function (params) {
            return 'Микрофон выключен.';
        },
        'notification.recording': function (params) {
            return 'Идет запись';
        },
        'notification.summarization': function (params) {
            return 'Идет конспект';
        },
        'notification.turn-on': function (params) {
            return 'Включить';
        },
        'notification.turn-on-camera': function (params) {
            return 'Включить камеру';
        },
        'notification.turn-on-microphone': function (params) {
            return 'Включить микрофон';
        },
        'notification.waiting-room': function (params) {
            return 'В комнате ожидания есть участники';
        },
        'pagination-next-page': function (params) {
            return 'Листать участников вправо';
        },
        'pagination-prev-page': function (params) {
            return 'Листать участников влево';
        },
        'participant-list.count': function (params) {
            return (
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'участник',
                    some: 'участника',
                    many: 'участников',
                })
            );
        },
        'participant-list.next-page': function (params) {
            return 'Следующая страница';
        },
        'participant-list.page-state': function (params) {
            return params['currentPage'] + ' из ' + params['totalPages'];
        },
        'participant-list.prev-page': function (params) {
            return 'Предыдущая страница';
        },
        'presenter-view': function (params) {
            return 'Вид докладчика';
        },
        'unmute-notification.both-camera-text': function (params) {
            return 'Включить камеру';
        },
        'unmute-notification.both-common-text': function (params) {
            return 'Камера и микрофон выключены.';
        },
        'unmute-notification.both-microphone-text': function (params) {
            return 'Включить микрофон';
        },
        'unmute-notification.camera-text': function (params) {
            return 'Камера выключена. Включить';
        },
        'unmute-notification.microphone-text': function (params) {
            return 'Микрофон выключен. Включить';
        },
        'unmute-notification.text': function (params) {
            return 'Микрофон в переговорке выключен. Чтобы включить его, последовательно нажмите символы';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['error-page'] = {
        'ask-for-camera-and-mic-permissions': function (params) {
            return 'Разрешите доступ\nк камере и микрофону';
        },
        'back-to-chats': function (params) {
            return 'Вернуться к чатам';
        },
        'broadcast-gone': function (params) {
            return 'Эта трансляция закончилась';
        },
        'broadcast-gone-v2': function (params) {
            return 'Трансляция закончилась';
        },
        'broadcast-gone-v2-with-datetime': function (params) {
            return 'Трансляция закончилась\n' + params['date'] + ' в ' + params['time'] + ' ';
        },
        'broadcast-not-found': function (params) {
            return 'Трансляция не найдена';
        },
        'broadcast-organization-mismatches-description': function (params) {
            return 'Присоединиться к трансляции могут только сотрудники организации. Убедитесь, что выбрали верный аккаунт.';
        },
        'broadcast-organization-mismatches-title': function (params) {
            return 'Это закрытая трансляция';
        },
        'broadcast-organization-mismatches-unauthorized-description': function (params) {
            return 'Присоединиться к трансляции могут только сотрудники организации. ';
        },
        'close-button-title': function (params) {
            return 'Закрыть';
        },
        'default-title': function (params) {
            return 'Произошла ошибка';
        },
        'download-yandex-telemost': function (params) {
            return 'Скачать Яндекс Телемост';
        },
        'forbidden-title': function (params) {
            return 'Доступ закрыт';
        },
        'gone-title': function (params) {
            return 'Эта встреча уже закончилась,\nно вы можете создать новую';
        },
        'how-to-add-permission-link': function (params) {
            return 'Как это сделать';
        },
        'no-camera-and-mic-permissions': function (params) {
            return 'Нет доступа к камере и микрофону';
        },
        'no-device-permission-text': function (params) {
            return 'Видеовстречи недоступны.\nРазрешите доступ к камере и микрофону.';
        },
        'not-found-title': function (params) {
            return 'Такой встречи не существует,\nно вы можете создать новую';
        },
        'not-in-experiment-title': function (params) {
            return 'Вам пока недоступно создание встреч.\nНо вы сможете подключиться, если вас пригласят';
        },
        'not-started-title': function (params) {
            return (
                'Эта встреча еще не началась, начнется ' +
                params['date'] +
                ' г. в ' +
                params['time'] +
                '. Подключиться можно в ' +
                params['startTime'] +
                '.'
            );
        },
        'organization-mismatches-description': function (params) {
            return 'Присоединиться к встрече могут только сотрудники организации. Убедитесь, что выбрали верный аккаунт.';
        },
        'organization-mismatches-title': function (params) {
            return 'Это закрытая встреча';
        },
        'organization-mismatches-unauthorized-button': function (params) {
            return 'Войти в аккаунт';
        },
        'organization-mismatches-unauthorized-description': function (params) {
            return 'Присоединиться к встрече могут только сотрудники организации.';
        },
        'organization-mismatches-yateam-button-primary': function (params) {
            return 'Сменить аккаунт';
        },
        'organization-mismatches-yateam-button-secondary': function (params) {
            return 'В приложение';
        },
        'organization-mismatches-yateam-description': function (params) {
            return 'Или попробуйте перейти в приложение.\nС личным аккаунтом зайти на рабочую встречу не получится';
        },
        'organization-mismatches-yateam-title': function (params) {
            return 'Смените аккаунт на @yandex-team.ru';
        },
        'overloaded-title': function (params) {
            return 'Сейчас сервис перегружен, но мы уже работаем над этой проблемой.';
        },
        'try-calls-in-disk': function (params) {
            return 'Попробуйте \n видеовстречи в Диске';
        },
        'try-telemost-app': function (params) {
            return 'Попробуйте приложение \n Телемост';
        },
        'unauthorized-subtitle': function (params) {
            return 'Чтобы создавать встречи,\nвойдите в аккаунт на Яндексе';
        },
        'unauthorized-title': function (params) {
            return 'Видеовстречи по ссылке';
        },
        'unsupported-browser-subtitle': function (params) {
            return (
                'Установите приложение ' +
                '<x-link-disk>' +
                'Яндекс Диск' +
                '</x-link-disk>' +
                ' для компьютера\nили воспользуйтесь ' +
                '<x-link-yabro>' +
                'Яндекс Браузером' +
                '</x-link-yabro>' +
                ', Google Chrome или Mozilla Firefox'
            );
        },
        'unsupported-browser-subtitle-no-ff': function (params) {
            return (
                'Установите приложение для компьютера\nили воспользуйтесь ' +
                '<x-link-yabro>' +
                'Яндекс Браузером' +
                '</x-link-yabro>' +
                ' или Google Chrome'
            );
        },
        'unsupported-browser-subtitle-touch': function (params) {
            return (
                'Скачайте приложение Телемоста или попробуйте ' +
                '<x-link-yabro>' +
                'Яндекс Браузер' +
                '</x-link-yabro>'
            );
        },
        'unsupported-browser-subtitle-v3': function (params) {
            return (
                'Скачайте Телемост на компьютер или попробуйте ' +
                '<x-link-yabro>' +
                'Яндекс Браузер' +
                '</x-link-yabro>'
            );
        },
        'unsupported-browser-subtitle2': function (params) {
            return (
                'Установите приложение для компьютера\nили воспользуйтесь ' +
                '<x-link-yabro>' +
                'Яндекс Браузером' +
                '</x-link-yabro>' +
                ', Google Chrome или Mozilla Firefox'
            );
        },
        'unsupported-browser-subtitle2-no-desktop': function (params) {
            return (
                'Воспользуйтесь ' +
                '<x-link-yabro>' +
                'Яндекс Браузером' +
                '</x-link-yabro>' +
                ', Google Chrome или Mozilla Firefox'
            );
        },
        'unsupported-electron': function (params) {
            return 'Эта версия Телемоста устарела, в ней видеовстречи больше не работают. Скачайте новую отдельную программу Яндекс Телемост.';
        },
        'unsupported-electron-button': function (params) {
            return 'Скачать';
        },
        'unsupported-messenger-description': function (params) {
            return 'Обновите или переустановите приложение. ' + '<x-link-help>' + 'Как это сделать?' + '</x-link-help>';
        },
        'unsupported-messenger-title': function (params) {
            return 'Для звонков нужна\nпоследняя версия Мессенджера';
        },
        'unsupported-mobile-bro-videocalls': function (params) {
            return 'В мобильных браузерах\nвидеовстречи пока недоступны.';
        },
        'unsupported-mobile-browser': function (params) {
            return 'В мобильных браузерах \n они пока не работают.';
        },
        'user-kicked-description': function (params) {
            return 'Попробуйте подключиться позже.';
        },
        'user-kicked-title': function (params) {
            return 'Вас удалили из этой встречи';
        },
        'user-kicked-with-ban-description': function (params) {
            return 'Встреча недоступна в течение дня, попробуйте подключиться позже.';
        },
        'usupported-browser-title': function (params) {
            return 'Телемост не работает\nв вашем браузере';
        },
        'usupported-browser-title-v2': function (params) {
            return 'В этом браузере Телемост не откроется';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['faq'] = {
        'answer-1': function (params) {
            return 'Яндекс Телемост — это видеовстречи по ссылке. В Телемосте можно собирать рабочие конференции, встречаться с семьей или устраивать видео-вечеринки. Достаточно просто создать встречу и отправить ссылку друзьям или коллегам.';
        },
        'answer-2': function (params) {
            return (
                'Если используете Телемост бесплатно, на встрече может быть не больше 40 человек. С ' +
                '<x-link-payment-plans>' +
                'тарифами для бизнеса' +
                '</x-link-payment-plans>' +
                ' встречи можно расширить до 1000 участников.'
            );
        },
        'answer-3': function (params) {
            return 'Видеовстречи в Телемосте не ограничены по времени — важное обсуждение не прервется внезапно.';
        },
        'answer-4': function (params) {
            return (
                'Да, можно. Чтобы использовать Телемост в коммерческих целях, зарегистрируйте организацию в Яндекс 360 для бизнеса. ' +
                '<x-link-business>' +
                'Подробнее ' +
                '</x-link-business>' +
                '\n'
            );
        },
        'answer-5': function (params) {
            return 'Перейдите на страницу Телемоста или откройте программу Телемост, затем нажмите «Запланировать». Укажите дату и время встречи, добавьте участников и нажмите «Создать» — встреча появится в вашем Яндекс Календаре. Также вы можете запланировать видеовстречу из самого Календаря: создайте событие в Календаре как обычно и в его настройках нажмите кнопку «Добавить видеовстречу».';
        },
        'answer-6': function (params) {
            return 'Пока виртуальный фон доступен только в программе Телемост для компьютера, в веб-версии настроить фон не получится. Если в вашей программе этой настройки нет, возможно, ваш процессор не поддерживает виртуальные фоны.';
        },
        'question-1': function (params) {
            return ' Что такое Телемост?';
        },
        'question-2': function (params) {
            return 'Сколько участников может быть на видеовстрече?';
        },
        'question-3': function (params) {
            return 'Какая максимальная длительность встреч?';
        },
        'question-4': function (params) {
            return 'Можно ли использовать Телемост для бизнеса или в коммерческих целях?';
        },
        'question-5': function (params) {
            return 'Как запланировать встречу заранее?';
        },
        'question-6': function (params) {
            return 'Почему у меня в Телемосте нет настройки виртуального фона?';
        },
        title: function (params) {
            return 'Частые вопросы';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['feedback'] = {
        cancel: function (params) {
            return 'Не хочу оценивать';
        },
        comment: function (params) {
            return 'Комментарий';
        },
        'contact-support': function (params) {
            return 'Написать в службу поддержки';
        },
        'feedback-description-hint': function (params) {
            return 'Опишите ситуацию как можно подробнее: перечислите свои действия по шагам и их результат';
        },
        'feedback-email-hint': function (params) {
            return 'Укажите адрес, мы на него ответим';
        },
        'feedback-form-header': function (params) {
            return 'Оцените качество связи';
        },
        message: function (params) {
            return 'Оцените качество связи\nпрошедшей встречи';
        },
        'message-placeholder': function (params) {
            return 'Расскажите, что случилось';
        },
        rate: function (params) {
            return 'Оценить';
        },
        'reason-bad-audio': function (params) {
            return 'Неразборчивый звук';
        },
        'reason-bad-video': function (params) {
            return 'Низкое качество видео';
        },
        'reason-disconnect': function (params) {
            return 'Встреча оборвалась ';
        },
        'reason-echo': function (params) {
            return 'Эхо или посторонние звуки';
        },
        'reason-no-audio': function (params) {
            return 'Не слышно меня или собеседников';
        },
        'reason-no-video': function (params) {
            return 'Не видно меня или собеседников';
        },
        'reason-title': function (params) {
            return 'Расскажите,\nчто вам не понравилось';
        },
        reason_audio_desync: function (params) {
            return 'Не совпадает с видео';
        },
        reason_audio_distorted: function (params) {
            return 'Прерывается или искажается';
        },
        reason_audio_echo: function (params) {
            return 'Эхо';
        },
        'reason_audio_no-data': function (params) {
            return 'Нет звука у меня или у собеседника';
        },
        reason_audio_noise: function (params) {
            return 'Внешний шум';
        },
        reason_audio_volume: function (params) {
            return 'Слишком громко или тихо';
        },
        reason_group_audio: function (params) {
            return 'Звук';
        },
        reason_group_sharing: function (params) {
            return 'Демонстрация экрана';
        },
        reason_group_video: function (params) {
            return 'Видео';
        },
        reason_sharing_distorted: function (params) {
            return 'Искажается';
        },
        'reason_sharing_no-data': function (params) {
            return 'Не запускается';
        },
        reason_video_distorted: function (params) {
            return 'Искажается';
        },
        reason_video_freezing: function (params) {
            return 'Зависает';
        },
        'reason_video_no-data': function (params) {
            return 'Не видно меня или собеседника';
        },
        'report-a-problem-button': function (params) {
            return 'Сообщить о проблеме';
        },
        'report-a-problem-form-header': function (params) {
            return 'Сообщение о проблеме';
        },
        'send-feedback-error': function (params) {
            return 'Не удалось отправить сообщение.\nПопробуйте еще раз.';
        },
        'star-rate': function (params) {
            return 'Выбрать ' + params['index'] + ' из ' + params['count'] + ' звёзд';
        },
        submit: function (params) {
            return 'Отправить';
        },
        'success-send-notification': function (params) {
            return 'Спасибо, что сообщили — Телемост станет лучше';
        },
        'success-send-notification-v2': function (params) {
            return 'Спасибо, получили вашу оценку';
        },
        title: function (params) {
            return 'Вы вышли из встречи';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['footer'] = {
        disclaimer: function (params) {
            return 'Используя Яндекс Телемост, вы соглашаетесь с условиями';
        },
        'terms-of-use': function (params) {
            return 'пользовательского соглашения';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['header'] = {
        'app-description': function (params) {
            return 'Бесплатные видеоконференции и встречи прямо в браузере. Подключение без регистрации, удобно с ПК и телефона. Работайте, учитесь и общайтесь онлайн';
        },
        'app-join-description': function (params) {
            return 'Подключайтесь и общайтесь без ограничений по времени';
        },
        'app-join-og-description': function (params) {
            return 'По ссылке вы сможете подключиться к звонку\n';
        },
        'app-telemessenger-chat-og-description': function (params) {
            return 'По ссылке вы сможете присоединиться к чату\n';
        },
        'app-telemessenger-description': function (params) {
            return 'Общайтесь в мессенджере с чатами и видеозвонками без ограничений по времени';
        },
        'app-telemessenger-invite-og-description': function (params) {
            return 'По ссылке откроется личный чат\n';
        },
        'join-og-title': function (params) {
            return 'Звонок в Яндекс Телемосте\n';
        },
        'join-title': function (params) {
            return 'Звонок в Яндекс Телемосте ';
        },
        logout: function (params) {
            return 'Выход';
        },
        'premium-button-text': function (params) {
            return 'Для бизнеса';
        },
        'premium-button-text-v2': function (params) {
            return 'Тарифы для бизнеса';
        },
        'telemessenger-chat-og-title': function (params) {
            return 'Чат в Яндекс Телемосте\n';
        },
        'telemessenger-invite-og-title': function (params) {
            return 'Приглашаю в Яндекс Телемост\n';
        },
        'telemessenger-title': function (params) {
            return 'Чат в Яндекс Телемосте';
        },
        title: function (params) {
            return 'Яндекс Телемост — бесплатные видеовстречи без регистрации и ограничения по времени';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['lists'] = {
        'months-genitive': function (params) {
            return 'января | февраля | марта | апреля | мая | июня | июля | августа | сентября | октября | ноября | декабря';
        },
        'months-nominative': function (params) {
            return 'Январь | Февраль | Март | Апрель | Май | Июнь | Июль | Август | Сентябрь | Октябрь | Ноябрь | Декабрь';
        },
        'week-days': function (params) {
            return 'воскресенье | понедельник | вторник | среда | четверг | пятница | суббота | воскресенье';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['moderation'] = {
        'access-level-organization': function (params) {
            return 'Только для сотрудников';
        },
        'access-level-public': function (params) {
            return 'Для всех пользователей';
        },
        'access-level-waiting-room-admins': function (params) {
            return 'Комната ожидания для всех';
        },
        'access-level-waiting-room-all': function (params) {
            return 'Комната ожидания включена';
        },
        'access-level-waiting-room-disabled': function (params) {
            return 'Выключена';
        },
        'access-level-waiting-room-enabled': function (params) {
            return 'Включена';
        },
        'access-level-waiting-room-organization': function (params) {
            return 'Комната ожидания для внешних';
        },
        'access-level-waiting-room-public': function (params) {
            return 'Комната ожидания выключена';
        },
        'action-change-avatar': function (params) {
            return 'Изменить аватар';
        },
        'action-change-name-and-avatar': function (params) {
            return 'Изменить имя и аватар';
        },
        'action-kick-user': function (params) {
            return 'Удалить со встречи';
        },
        'action-make-an-co-host': function (params) {
            return 'Назначить соорганизатором';
        },
        'action-make-an-co-host-v2': function (params) {
            return 'Сделать соорганизатором';
        },
        'action-make-an-moderator': function (params) {
            return 'Сделать администратором';
        },
        'action-mute-all-audio': function (params) {
            return 'Выключить всем микрофоны';
        },
        'action-mute-all-reactions-hand': function (params) {
            return 'Опустить всем руки';
        },
        'action-mute-all-video': function (params) {
            return 'Выключить всем камеры';
        },
        'action-mute-reaction-hand': function (params) {
            return 'Опустить руку';
        },
        'action-mute-screensharing': function (params) {
            return 'Остановить демонстрацию';
        },
        'action-mute-video': function (params) {
            return 'Выключить камеру';
        },
        'action-stop-all-local-recordings': function (params) {
            return 'Остановить все записи на компьютер';
        },
        'action-stop-local-recording': function (params) {
            return 'Остановить запись на компьютер';
        },
        'action-unmake-an-co-host': function (params) {
            return 'Забрать права соорганизатора';
        },
        'co-host': function (params) {
            return 'соорганизатор';
        },
        host: function (params) {
            return 'организатор';
        },
        'modal-confirm-access-level-limit-text': function (params) {
            return 'В комнате ожидания сотрудников больше, чем может вместить встреча';
        },
        'modal-confirm-access-level-limit-title': function (params) {
            return 'На встречу не попадёт часть сотрудников';
        },
        'modal-confirm-end-call-button-confirm': function (params) {
            return 'Завершить';
        },
        'modal-confirm-end-call-content': function (params) {
            return 'Участники не смогут остаться на встрече и продолжить обсуждение';
        },
        'modal-confirm-end-call-header': function (params) {
            return 'Завершить встречу для всех?';
        },
        'modal-confirm-end-call-with-broadcast-content': function (params) {
            return 'Трансляция тоже завершится';
        },
        'modal-kick-confirm-button-cancel': function (params) {
            return 'Отмена';
        },
        'modal-kick-confirm-button-cancel-v2': function (params) {
            return 'Не удалять';
        },
        'modal-kick-confirm-button-confirm': function (params) {
            return 'Удалить';
        },
        'modal-kick-confirm-checkbox-label': function (params) {
            return 'Закрыть доступ на 24 часа';
        },
        'modal-kick-confirm-checkbox-label-v2': function (params) {
            return 'Запретить подключение на 24 часа\n';
        },
        'modal-kick-confirm-text': function (params) {
            return 'После удаления ' + params['name'] + ' сможет присоединиться к этой встрече снова.';
        },
        'modal-kick-confirm-text-open': function (params) {
            return (
                'После удаления ' +
                params['name'] +
                ' сможет присоединиться к этой встрече снова — она открыта для всех.'
            );
        },
        'modal-kick-confirm-text-open-ban': function (params) {
            return 'Чтобы ограничивать доступ и блокировать пользователей на встрече, смените тип доступа в списке участников.';
        },
        'modal-kick-confirm-text-open-ban-v2': function (params) {
            return 'Пользователь сможет подключиться снова, если не запретить подключение';
        },
        'modal-kick-confirm-text-open-wr': function (params) {
            return 'Комната ожидания';
        },
        'modal-kick-confirm-text-wr-disabled': function (params) {
            return 'Пользователь не сможет подключиться снова. Включите комнату ожидания — так он не попадёт на встречу даже с другим аккаунтом';
        },
        'modal-kick-confirm-text-wr-enabled': function (params) {
            return 'Пользователь не сможет подключиться снова. Если подключится с другим аккаунтом — попадёт в комнату ожидания';
        },
        'modal-kick-confirm-title': function (params) {
            return 'Удалить со встречи?';
        },
        'modal-kick-confirm-title-v2': function (params) {
            return 'Удалить ' + params['name'] + ' со встречи?';
        },
        'modal-stop-all-recordings-description': function (params) {
            return 'Записанное сохранится на компьютерах участников';
        },
        'modal-stop-all-recordings-with-removal-label': function (params) {
            return 'Удалить записи';
        },
        'modal-stop-recording-cancel-label': function (params) {
            return 'Не останавливать';
        },
        'modal-stop-recording-confirm-label': function (params) {
            return 'Остановить';
        },
        'modal-stop-recording-description': function (params) {
            return 'Записанное сохранится на компьютере участника';
        },
        'modal-stop-recording-header': function (params) {
            return 'Остановить запись?';
        },
        'modal-stop-recording-with-removal-label': function (params) {
            return 'Удалить запись';
        },
        'modal-stop-recordings-header': function (params) {
            return 'Остановить записи?';
        },
        'notification-action-error': function (params) {
            return 'Что-то пошло не так. Попробуйте еще раз';
        },
        'notification-action-error-kick': function (params) {
            return 'Не удалось удалить участника. Попробуйте еще раз';
        },
        'notification-action-error-make-an-co-host': function (params) {
            return 'Не удалось сделать участника соорганизатором. Попробуйте ещё раз';
        },
        'notification-action-error-mute-all-audio': function (params) {
            return 'Не удалось выключить микрофоны всех участников. Попробуйте ещё раз';
        },
        'notification-action-error-mute-all-recordings': function (params) {
            return 'Не удалось остановить записи';
        },
        'notification-action-error-mute-all-video': function (params) {
            return 'Не удалось выключить камеры всех участников. Попробуйте ещё раз';
        },
        'notification-action-error-mute-audio': function (params) {
            return 'Не удалось выключить микрофон участника. Попробуйте ещё раз';
        },
        'notification-action-error-mute-recording': function (params) {
            return params['name'] + ' всё ещё записывает встречу — не удалось остановить';
        },
        'notification-action-error-mute-recordings-no-permission': function (params) {
            return 'Организатор запретил останавливать чужие записи';
        },
        'notification-action-error-mute-screensharing': function (params) {
            return 'Не удалось выключить демонстрацию экрана участника. Попробуйте ещё раз';
        },
        'notification-action-error-mute-video': function (params) {
            return 'Не удалось выключить камеру участника. Попробуйте ещё раз';
        },
        'notification-action-error-permissions': function (params) {
            return 'Не удалось изменить права участников';
        },
        'notification-action-error-set-broadcast-access-level': function (params) {
            return 'Не удалось изменить доступность трансляции. Попробуйте ещё раз';
        },
        'notification-action-error-set-conference-access-level': function (params) {
            return 'Не удалось изменить доступность встречи. Попробуйте ещё раз';
        },
        'notification-action-success-mute-all-recordings': function (params) {
            return 'Встречу больше не записывают. Записанное удалится';
        },
        'notification-action-success-mute-all-recordings-without-removal': function (params) {
            return 'Встречу больше не записывают';
        },
        'notification-action-success-mute-recording': function (params) {
            return params['name'] + ' больше не записывает встречу. Записанное удалится';
        },
        'notification-action-success-mute-recording-without-removal': function (params) {
            return params['name'] + ' больше не записывает встречу';
        },
        'notification-confirm-ban-recording-content': function (params) {
            return 'Запись, которую вы начали вести, не сохранится';
        },
        'notification-confirm-ban-recording-header': function (params) {
            return 'Организатор запретил записывать встречу';
        },
        'notification-confirm-mute-recording-content': function (params) {
            return 'Записанное не сохранится';
        },
        'notification-confirm-mute-recording-header': function (params) {
            return 'Вашу запись остановили';
        },
        'notification-confirm-mute-recording-without-removal-content': function (params) {
            return 'Записанное сохранится на компьютере';
        },
        'notification-iam-new-co-host': function (params) {
            return params['name'] + ' сделал(а) вас соорганизатором встречи';
        },
        'notification-iam-not-co-host': function (params) {
            return 'Вы больше не соорганизатор этой встречи';
        },
        'notification-iam-not-co-host-v2': function (params) {
            return 'Организатор забрал у вас права соорганизатора';
        },
        'notification-kick': function (params) {
            return 'Вы удалили со встречи участника ' + params['name'];
        },
        'notification-kick-with-ban': function (params) {
            return 'Вы удалили со встречи участника ' + params['name'] + ' на 24 часа';
        },
        'notification-make-admin-error': function (params) {
            return params['name'] + ' пока не соорганизатор — не удалось дать права';
        },
        'notification-make-member-error': function (params) {
            return params['name'] + ' всё ещё соорганизатор — не удалось забрать права ';
        },
        'notification-my-audio-was-muted-by-co-host': function (params) {
            return 'Соорганизатор выключил(а) ваш микрофон';
        },
        'notification-my-audio-was-muted-by-host': function (params) {
            return 'Организатор выключил(а) ваш микрофон';
        },
        'notification-my-recording-was-muted-by': function (params) {
            return params['name'] + ' остановил(а) вашу запись на компьютер';
        },
        'notification-my-screensharing-was-muted-by-co-host': function (params) {
            return 'Соорганизатор остановил(а) демонстрацию вашего экрана';
        },
        'notification-my-screensharing-was-muted-by-host': function (params) {
            return 'Организатор остановил(а) демонстрацию вашего экрана';
        },
        'notification-my-video-was-muted-by-co-host': function (params) {
            return 'Соорганизатор выключил(а) вашу камеру';
        },
        'notification-my-video-was-muted-by-host': function (params) {
            return 'Организатор выключил(а) вашу камеру';
        },
        'notification-new-co-host': function (params) {
            return params['name'] + ' теперь соорганизатор этой встречи';
        },
        'notification-no-longer-co-host': function (params) {
            return params['name'] + ' больше не соорганизатор этой встречи';
        },
        'notification-no-longer-co-host-v2': function (params) {
            return params['name'] + ' больше не соорганизатор';
        },
        'organizer-revoked-access-level-edit-permission': function (params) {
            return 'Организатор запретил настраивать комнату ожидания';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['native-app-banner'] = {
        'app-description': function (params) {
            return 'Открыть приложение или скачать';
        },
        'app-link': function (params) {
            return 'Ссылка на приложение';
        },
        'app-name': function (params) {
            return 'Яндекс Телемост';
        },
        'app-open-button': function (params) {
            return 'СКАЧАТЬ';
        },
        description: function (params) {
            return 'Пишите и звоните своим контактам из телефона';
        },
        'description-v2': function (params) {
            return 'Для звонков и переписки в чатах';
        },
        download: function (params) {
            return 'Скачать';
        },
        'download-telemost': function (params) {
            return 'Скачать Телемост ';
        },
        'telemost-has-chats': function (params) {
            return 'В приложении Телемоста есть чаты';
        },
        title: function (params) {
            return 'В приложении есть чаты';
        },
        'title-v2': function (params) {
            return 'Мобильное приложение';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['native-app-modal'] = {
        description: function (params) {
            return 'Чаты и звонки без ограничений. Будьте на связи с коллегами и близкими\n';
        },
        title: function (params) {
            return 'Мобильное приложение Телемоста';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['new-call'] = {
        'go-on': function (params) {
            return 'Переключиться';
        },
        'modal-title': function (params) {
            return 'Вы уже на встрече.' + params['spacebreak'] + 'Хотите переключиться на другую?';
        },
        'not-now': function (params) {
            return 'Не сейчас';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['overlay'] = {
        'ask-for-introduction': function (params) {
            return 'Представьтесь, пожалуйста';
        },
        'connect-call-button': function (params) {
            return 'Подключиться к встрече';
        },
        'join-broadcast-button': function (params) {
            return 'Подключиться к трансляции';
        },
        'join-button': function (params) {
            return 'Подключиться';
        },
        'join-created-broadcast-description': function (params) {
            return 'Вас увидят только участники. Проверьте видео и звук.';
        },
        'join-created-broadcast-title': function (params) {
            return 'Вы готовы подключиться?';
        },
        'join-started-broadcast-description': function (params) {
            return 'Вас увидят все зрители трансляции. Проверьте видео и звук.';
        },
        'join-started-broadcast-title': function (params) {
            return 'Вы готовы подключиться?';
        },
        'nickname-title-label': function (params) {
            return 'Ваше имя на встрече';
        },
        'no-fitting-account': function (params) {
            return 'Нет нужного аккаунта';
        },
        'quality-message': function (params) {
            return 'Встреча пройдёт в браузере — так качество связи будет выше';
        },
        'select-account': function (params) {
            return 'Выберите аккаунт';
        },
        'to-home-screen': function (params) {
            return 'На главную';
        },
        'waiting-room-status-1': function (params) {
            return 'Вы в комнате ожидания...';
        },
        'waiting-room-status-2': function (params) {
            return 'Организатор видит ваш запрос...';
        },
        'you-are-joining-text': function (params) {
            return (
                'Вы подключаетесь' +
                params['spacebreak'] +
                'к видеовстрече' +
                i18n['tanker']['dynamic']['toggle']({
                    condition: params['showTail'],
                    true: ',\nне забудьте представиться',
                    false: '',
                }) +
                '\n'
            );
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['participants-sidebar'] = {
        'cloud-recording-in-progress': function (params) {
            return 'Идёт запись на Яндекс Диск';
        },
        'cloud-recording-member-tip': function (params) {
            return 'Ссылка будет в чате встречи';
        },
        'cloud-recording-member-tip-v2': function (params) {
            return 'Ссылка появится в чате, но не сразу — обработка займёт время';
        },
        'cloud-recording-owner-tip': function (params) {
            return 'Ссылка будет в чате встречи и на почте';
        },
        'cloud-recording-owner-tip-v2': function (params) {
            return 'Ссылка появится в чате и на почте, но не сразу — обработка займёт время';
        },
        'conference-limit-error-text': function (params) {
            return 'Все попадают в комнату ожидания';
        },
        'conference-limit-error-title': function (params) {
            return 'На встрече нет мест';
        },
        'conference-limit-warning-text': function (params) {
            return 'Всех ожидающих впустить не получится';
        },
        'conference-limit-warning-title': function (params) {
            return (
                'Лимит встречи — ' +
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'участник',
                    some: 'участника',
                    many: 'участников',
                })
            );
        },
        'participants-search-stub-text': function (params) {
            return 'Попробуйте написать по-другому';
        },
        'participants-search-stub-title': function (params) {
            return 'Такого участника нет';
        },
        'peers-tab-conference': function (params) {
            return 'На встрече';
        },
        'peers-tab-waiting-room': function (params) {
            return 'Ожидают';
        },
        'waiting-room-sort-alfa': function (params) {
            return 'По алфавиту';
        },
        'waiting-room-sort-time': function (params) {
            return 'По порядку входа';
        },
        'waiting-room-stub-text': function (params) {
            return 'Здесь будут участники, которые ждут, когда их впустят';
        },
        'waiting-room-stub-title': function (params) {
            return 'Комната ожидания пуста';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['permission-help'] = {
        header: function (params) {
            return 'Разрешите Яндекс Диску записывать экран \nв настройках macOS';
        },
        message: function (params) {
            return 'Откройте Защита и безопасность > Запись экрана и отметьте Яндекс Диск в списке справа';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['plan-call'] = {
        calendar: function (params) {
            return 'Календарь';
        },
        'closed-meeting': function (params) {
            return 'Это закрытая встреча. Обратитесь к организатору, чтобы он добавил вас в список участников в Календаре.';
        },
        'error-planned-broadcast': function (params) {
            return 'Не удалось запланировать трансляцию';
        },
        'error-planned-call': function (params) {
            return 'Не удалось запланировать встречу';
        },
        'go-to-event': function (params) {
            return 'Показать';
        },
        'success-planned-broadcast': function (params) {
            return 'Трансляция запланирована в Календаре. Перед трансляцией участникам придёт напоминание. А зрителям отправьте ссылку вручную.';
        },
        'success-planned-call': function (params) {
            return 'Встреча запланирована в Календаре. \nПеред встречей всем участникам \nпридёт напоминание.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['promo'] = {
        'link-preview': function (params) {
            return 'Мессенджер с чатами и видеозвонками без ограничений по времени';
        },
        'mac-app': function (params) {
            return 'Телемост для macOS';
        },
        'promo-mac-app': function (params) {
            return 'Попробуйте Телемост для macOS';
        },
        'promo-win-app': function (params) {
            return 'Попробуйте Телемост\nдля Windows';
        },
        'win-app': function (params) {
            return 'Телемост для Windows';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['record'] = {
        'file-name-postfix-chat': function (params) {
            return 'чат';
        },
        'file-name-postfix-record': function (params) {
            return 'запись';
        },
        'file-name-prefix': function (params) {
            return 'Запись встречи';
        },
        'general-record-error': function (params) {
            return 'Запись остановлена. Во время записи произошла ошибка.';
        },
        'last-record-download': function (params) {
            return 'Скачать запись';
        },
        'last-record-download-again': function (params) {
            return 'Скачать ещё раз';
        },
        'last-record-download-error': function (params) {
            return 'Не удалось подготовить запись к скачиванию. Попробуйте ещё раз';
        },
        'last-record-download-hint': function (params) {
            return 'Скачать запись встречи от ' + params['date'];
        },
        'last-record-download-requested-hint': function (params) {
            return 'Если загрузка записи от ' + params['date'] + ' прервалась, освободите место и скачайте её ещё раз';
        },
        'last-record-recovery-download-hint': function (params) {
            return (
                'Запись встречи от ' +
                params['date'] +
                ' хранится в этом браузере. Освободите место на компьютере перед скачиванием'
            );
        },
        'notify-save-chat-history-cancel-button': function (params) {
            return 'Отмена';
        },
        'notify-save-chat-history-save-button': function (params) {
            return 'Сохранить';
        },
        'notify-save-chat-history-text': function (params) {
            return 'Сохранить все сообщения из чата встречи?';
        },
        'quota-exceed-error': function (params) {
            return 'Закончилось место на компьютере. Запись остановлена. Освободите место и скачайте сохранённую часть записи на главной';
        },
        'some-participants-recording': function (params) {
            return 'Несколько участников ведут запись на компьютер';
        },
        'somebody-recording': function (params) {
            return params['name'] + ' ведёт запись на компьютер';
        },
        'waiting-download': function (params) {
            return 'Пожалуйста, подождите. Скачивание записи встречи сейчас начнется.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['room-agent'] = {
        'alone-screen-text-first-line': function (params) {
            return 'Чтобы посмотреть список команд,';
        },
        'alone-screen-text-second-line': function (params) {
            return 'откройте клавиатуру на планшете и нажмите 1';
        },
        'alone-screen-title-first-line': function (params) {
            return 'Вы на встрече.';
        },
        'alone-screen-title-second-line': function (params) {
            return 'Других участников пока нет';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['settings-v2'] = {
        'account-edit': function (params) {
            return 'Редактировать';
        },
        'account-log-in': function (params) {
            return 'Войти';
        },
        'account-stub-title': function (params) {
            return 'Войдите с Яндекс ID';
        },
        'additional-settings-title': function (params) {
            return 'Дополнительно';
        },
        'bandwidth-effective-4k-codec-badge': function (params) {
            return 'Экспериментально';
        },
        'bandwidth-effective-4k-codec-label': function (params) {
            return 'Оптимизация трафика при демонстрации экрана';
        },
        'camera-option-back': function (params) {
            return 'Тыловая камера';
        },
        'camera-option-front': function (params) {
            return 'Фронтальная камера';
        },
        'default-speaker-device': function (params) {
            return 'Default speaker';
        },
        'develop-crash-call-button': function (params) {
            return 'Вызвать';
        },
        'develop-crash-call-label': function (params) {
            return 'Краш звонка';
        },
        'develop-do-not-check-desktop-app-existence': function (params) {
            return 'Не проверять наличие ПО';
        },
        'device-is-not-connected': function (params) {
            return 'Не подключён';
        },
        'diagnostic-access-device-btn': function (params) {
            return 'Как дать доступ';
        },
        'diagnostic-access-granting-hint': function (params) {
            return 'Дайте доступ в настройках компьютера и браузера';
        },
        'diagnostic-device-permission-denied': function (params) {
            return 'Нет доступа';
        },
        'diagnostic-input-recording-btn': function (params) {
            return 'Запись...';
        },
        'diagnostic-input-start-tooltip': function (params) {
            return 'Запишется 5 секунд \nи сразу воспроизведётся';
        },
        'diagnostic-output-start-tooltip': function (params) {
            return 'Заиграет мелодия';
        },
        'diagnostic-play-btn': function (params) {
            return 'Проверить';
        },
        'diagnostic-playing-melody': function (params) {
            return 'Играет мелодия';
        },
        'diagnostic-playing-record': function (params) {
            return 'Играет запись';
        },
        'diagnostic-record-btn': function (params) {
            return 'Проверить';
        },
        'diagnostic-stop-playing-btn': function (params) {
            return 'Остановить';
        },
        'diagnostic-stop-record-btn': function (params) {
            return 'Остановить';
        },
        'diagnostics-bitrate': function (params) {
            return 'Битрейт';
        },
        'diagnostics-cpu': function (params) {
            return 'CPU';
        },
        'diagnostics-mos': function (params) {
            return 'MOS';
        },
        'diagnostics-packets-lost': function (params) {
            return 'Потерянные пакеты';
        },
        'diagnostics-rtt': function (params) {
            return 'RTT';
        },
        'feedback-form-description-placeholder': function (params) {
            return 'Расскажите как можно подробнее, что случилось';
        },
        'feedback-form-mail-error': function (params) {
            return 'Проверьте, нет ли опечаток';
        },
        'feedback-form-mail-placeholder': function (params) {
            return 'Почта';
        },
        'feedback-form-submit': function (params) {
            return 'Отправить';
        },
        'hide-participants-video-description': function (params) {
            return 'Снизит нагрузку на сеть';
        },
        'hide-participants-video-label': function (params) {
            return 'Скрыть видео участников';
        },
        'kilobits-short': function (params) {
            return 'кбит/с';
        },
        'matrix-info-could-not-load': function (params) {
            return 'Информация не загрузилась';
        },
        'meeting-summarization': function (params) {
            return 'Конспект встречи';
        },
        'meeting-summarization-v2': function (params) {
            return 'Конспект от Алисы Про';
        },
        'menu-item-account': function (params) {
            return 'Аккаунт';
        },
        'menu-item-develop': function (params) {
            return 'Разработка';
        },
        'menu-item-diagnostics': function (params) {
            return 'Диагностика';
        },
        'menu-item-help': function (params) {
            return 'Справка и поддержка';
        },
        'menu-item-permissions': function (params) {
            return 'Права участников';
        },
        'menu-item-sound': function (params) {
            return 'Звук';
        },
        'menu-item-theme': function (params) {
            return 'Внешний вид';
        },
        'menu-item-video': function (params) {
            return 'Видео';
        },
        'menu-item-virtual-background': function (params) {
            return 'Фон на встрече';
        },
        'milliseconds-short': function (params) {
            return 'мс';
        },
        'mos-quality-excellent': function (params) {
            return 'Отличное';
        },
        'mos-quality-good': function (params) {
            return 'Хорошее';
        },
        'mos-quality-poor': function (params) {
            return 'Плохое';
        },
        'new-ui-tumbler-label': function (params) {
            return 'Новый Телемост';
        },
        'permission-ban-cloud-recording': function (params) {
            return 'Записывать встречу на Яндекс Диск';
        },
        'permission-ban-recording': function (params) {
            return 'Записывать встречу на компьютер';
        },
        'permission-ban-summarization': function (params) {
            return 'Конспектировать встречу с YandexGPT';
        },
        'permission-ban-summarization-v2': function (params) {
            return 'Конспектировать встречу с Алисой Про';
        },
        'permissions-description': function (params) {
            return 'У соорганизаторов всегда есть все возможности';
        },
        'permissions-description-v2': function (params) {
            return 'Права соорганизаторов настраивает администратор организации';
        },
        'permissions-extended-apply': function (params) {
            return 'Применить';
        },
        'permissions-extended-by-default': function (params) {
            return 'Настройки по умолчанию';
        },
        'permissions-extended-by-default-return': function (params) {
            return 'Вернуть';
        },
        'permissions-extended-cancel': function (params) {
            return 'Сбросить';
        },
        'permissions-extended-header': function (params) {
            return 'Права на этой встрече';
        },
        'permissions-extended-reset-modal-cancel': function (params) {
            return 'Не сбрасывать';
        },
        'permissions-extended-reset-modal-confirm': function (params) {
            return 'Сбросить';
        },
        'permissions-extended-reset-modal-description': function (params) {
            return 'Права на встрече останутся прежними';
        },
        'permissions-extended-reset-title': function (params) {
            return 'Сбросить изменения?';
        },
        'permissions-extended-return-to-default-modal-cancel': function (params) {
            return 'Отменить';
        },
        'permissions-extended-return-to-default-modal-confirm': function (params) {
            return 'Вернуть';
        },
        'permissions-extended-return-to-default-modal-description': function (params) {
            return 'Права изменятся на этой встрече. В созданных раньше встречах — не изменятся';
        },
        'permissions-extended-return-to-default-modal-title': function (params) {
            return 'Вернуть настройки прав по умолчанию?';
        },
        'permissions-group-camera': function (params) {
            return 'Камера';
        },
        'permissions-group-close-room': function (params) {
            return 'Завершение встречи';
        },
        'permissions-group-cloud-recording': function (params) {
            return 'Запись встречи на Яндекс Диск';
        },
        'permissions-group-conference-permissions': function (params) {
            return 'Права на этой встрече';
        },
        'permissions-group-desktop': function (params) {
            return 'Демонстрация экрана';
        },
        'permissions-group-microphone': function (params) {
            return 'Микрофон';
        },
        'permissions-group-recording': function (params) {
            return 'Запись встречи на компьютер';
        },
        'permissions-group-summarization': function (params) {
            return 'Конспект встречи';
        },
        'permissions-group-summarization-v2': function (params) {
            return 'Конспект от Алисы Про';
        },
        'permissions-group-waiting-room': function (params) {
            return 'Комната ожидания';
        },
        'permissions-header': function (params) {
            return 'Права участников на этой встрече';
        },
        'pip-active-tumbler-label': function (params) {
            return 'Включить PiP';
        },
        'receive-calendar-summary-on-mail': function (params) {
            return 'Получать конспект на почту, если приглашены в Яндекс Календаре';
        },
        'receive-summary-on-mail': function (params) {
            return 'Получать конспект встречи на почту';
        },
        'receive-summary-on-mail-v2': function (params) {
            return 'Получать конспект на почту, если были на встрече во время конспектирования';
        },
        'reload-matrix': function (params) {
            return 'Обновить';
        },
        'role-permission-access-level-edit': function (params) {
            return 'Настраивать комнату ожидания\n';
        },
        'role-permission-admit': function (params) {
            return 'Впускать на встречу тех, кто в комнате ожидания\n';
        },
        'role-permission-calendar-summarization-receive': function (params) {
            return 'Получать конспект на почту, если приглашён в Яндекс Календаре';
        },
        'role-permission-camera': function (params) {
            return 'Включать камеру';
        },
        'role-permission-camera-ban': function (params) {
            return 'Запрещать всем включать камеры';
        },
        'role-permission-camera-mute': function (params) {
            return 'Выключать камеры всем';
        },
        'role-permission-camera-unban-self': function (params) {
            return 'Снимать с себя запрет на включение камеры';
        },
        'role-permission-close-room': function (params) {
            return 'Завершать встречу для всех';
        },
        'role-permission-cloud-recording': function (params) {
            return 'Запускать и останавливать запись';
        },
        'role-permission-conference-permissions-edit-matrix': function (params) {
            return 'Менять права на этой встрече';
        },
        'role-permission-desktop': function (params) {
            return 'Запускать демонстрацию экрана';
        },
        'role-permission-desktop-mute': function (params) {
            return 'Останавливать чужую демонстрацию';
        },
        'role-permission-desktop-override': function (params) {
            return 'Запускать демонстрацию вместо идущей';
        },
        'role-permission-desktop-unban-self': function (params) {
            return 'Снимать с себя запрет на демонстрацию экрана';
        },
        'role-permission-microphone': function (params) {
            return 'Включать микрофон\n';
        },
        'role-permission-microphone-ban': function (params) {
            return 'Запрещать всем включать микрофоны\n';
        },
        'role-permission-microphone-mute': function (params) {
            return 'Выключать микрофоны всем';
        },
        'role-permission-microphone-unban-self': function (params) {
            return 'Снимать с себя запрет на включение микрофона';
        },
        'role-permission-recording': function (params) {
            return 'Записывать встречу';
        },
        'role-permission-recording-mute': function (params) {
            return 'Останавливать чужие записи';
        },
        'role-permission-recording-mute-all': function (params) {
            return 'Останавливать чужие записи';
        },
        'role-permission-recording-recording-unban-self': function (params) {
            return 'Снимать с себя запрет на запись встречи';
        },
        'role-permission-summarization': function (params) {
            return 'Запускать и останавливать конспектирование';
        },
        'role-permission-summarization-receive': function (params) {
            return 'Получать конспект на почту, если был на встрече во время конспектирования\n';
        },
        'role-tab-admin': function (params) {
            return 'Соорганизатор';
        },
        'role-tab-member': function (params) {
            return 'Участник';
        },
        'section-account-title': function (params) {
            return 'Аккаунт';
        },
        'section-develop-title': function (params) {
            return 'Разработка';
        },
        'section-diagnostics-subtitle': function (params) {
            return 'Здесь отображается качество связи';
        },
        'section-diagnostics-title': function (params) {
            return 'Диагностика';
        },
        'section-help-title': function (params) {
            return 'Справка и поддержка';
        },
        'section-permissions-extended-title': function (params) {
            return 'Права участников';
        },
        'section-sound-title': function (params) {
            return 'Звук';
        },
        'section-theme-subtitle': function (params) {
            return 'Такой фон будет в Телемосте, Почте и Диске';
        },
        'section-theme-title': function (params) {
            return 'Тема оформления в Яндекс 360';
        },
        'sharing-zoom-active-tumbler-label': function (params) {
            return 'Включить приближение демонстрации экрана';
        },
        'sound-change-not-supported-title': function (params) {
            return 'В этом браузере настроить звук не получится';
        },
        'sound-join-with-microphone-off': function (params) {
            return 'Подключаться с выключенным микрофоном';
        },
        'sound-microphone': function (params) {
            return 'Микрофон';
        },
        'sound-noise-cancellation': function (params) {
            return 'Шумоподавление';
        },
        'sound-noise-cancellation-auto': function (params) {
            return 'Автоматическое';
        },
        'sound-noise-cancellation-auto-description': function (params) {
            return 'Подстраивается под уровень шума';
        },
        'sound-noise-cancellation-auto-description-v2': function (params) {
            return 'Высокое или низкое — подстраивается под нагрузку на компьютер';
        },
        'sound-noise-cancellation-auto-v2': function (params) {
            return 'Адаптивное';
        },
        'sound-noise-cancellation-disabled': function (params) {
            return 'Отключено';
        },
        'sound-noise-cancellation-high': function (params) {
            return 'Высокое';
        },
        'sound-noise-cancellation-high-description': function (params) {
            return 'Шум кафе или улицы';
        },
        'sound-noise-cancellation-high-description-v2': function (params) {
            return 'Убирает весь шум. Может снижать скорость работы компьютера';
        },
        'sound-noise-cancellation-low': function (params) {
            return 'Низкое';
        },
        'sound-noise-cancellation-low-description': function (params) {
            return 'Стук клавиш, шуршание бумаги';
        },
        'sound-noise-cancellation-low-description-v2': function (params) {
            return 'Убирает слабый шум';
        },
        'sound-speaker': function (params) {
            return 'Динамик';
        },
        'support-help-go-to': function (params) {
            return 'Перейти';
        },
        'support-help-title': function (params) {
            return 'Справка';
        },
        'support-report-problem': function (params) {
            return 'Написать';
        },
        'support-title': function (params) {
            return 'Служба поддержки';
        },
        title: function (params) {
            return 'Настройки';
        },
        'unsupported-browser-subtitle': function (params) {
            return (
                'Установите ' +
                '<x-link-telemost>' +
                'Телемост для компьютера' +
                '</x-link-telemost>' +
                ' или попробуйте ' +
                '<x-link-yabro>' +
                'Яндекс Браузер' +
                '</x-link-yabro>'
            );
        },
        'video-background-tumbler-label': function (params) {
            return 'Динамический фон';
        },
        'video-camera': function (params) {
            return 'Камера';
        },
        'video-change-not-supported-description': function (params) {
            return (
                'Установите ' +
                '<x-link-telemost>' +
                'Телемост для компьютера' +
                '</x-link-telemost>' +
                ' или попробуйте ' +
                '<x-link-yabro>' +
                'Яндекс Браузер' +
                '</x-link-yabro>'
            );
        },
        'video-change-not-supported-title': function (params) {
            return 'В этом браузере настроить камеру не получится';
        },
        'video-join-with-camera-off': function (params) {
            return 'Подключаться с выключенной камерой';
        },
        'video-show-me': function (params) {
            return 'Видеть себя на встрече';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['settings'] = {
        account: function (params) {
            return 'Аккаунт';
        },
        camera: function (params) {
            return 'Камера';
        },
        'camera-background-blurred': function (params) {
            return 'Размытый';
        },
        'camera-background-none': function (params) {
            return 'Без фона';
        },
        'camera-option-back': function (params) {
            return 'Тыловая камера';
        },
        'camera-option-front': function (params) {
            return 'Фронтальная камера';
        },
        'change-avatar': function (params) {
            return 'Изменить аватар';
        },
        'change-name-and-avatar': function (params) {
            return 'Изменить имя и аватар';
        },
        'disclaimer-before-connection': function (params) {
            return 'Предупреждение перед подключением';
        },
        'do-not-check-desktop-app-existence': function (params) {
            return 'Не проверять наличие ПО';
        },
        'help-and-support': function (params) {
            return 'Справка и поддержка';
        },
        'hide-participants-video': function (params) {
            return 'Скрыть видео участников';
        },
        'hide-participants-video-description': function (params) {
            return 'Снизит нагрузку на сеть';
        },
        'join-with-camera-off': function (params) {
            return 'Подключаться с выключенной камерой';
        },
        'join-with-microphone-off': function (params) {
            return 'Подключаться с выключенным микрофоном';
        },
        login: function (params) {
            return 'Войти в аккаунт';
        },
        logout: function (params) {
            return 'Выйти из аккаунта';
        },
        mic: function (params) {
            return 'Микрофон';
        },
        'no-theme': function (params) {
            return 'Без темы';
        },
        'noise-cancellation-auto': function (params) {
            return 'Автоматически';
        },
        'noise-cancellation-auto-v2': function (params) {
            return 'Адаптивное';
        },
        'noise-cancellation-high': function (params) {
            return 'Сильное';
        },
        'noise-cancellation-low': function (params) {
            return 'Слабое';
        },
        'noise-cancellation-title': function (params) {
            return 'Шумоподавление';
        },
        'only-beta-testers': function (params) {
            return 'Только участники бета-тестирования';
        },
        'permission-ban-cloud-recording': function (params) {
            return 'Записывать встречу на Яндекс Диск';
        },
        'permission-ban-recording': function (params) {
            return 'Записывать встречу на компьютер';
        },
        'permission-ban-summarization': function (params) {
            return 'Конспектировать встречу с YandexGPT';
        },
        'permissions-explanation': function (params) {
            return 'У соорганизаторов всегда есть все возможности';
        },
        'permissions-header': function (params) {
            return 'Права участников на этой встрече';
        },
        'permissions-members': function (params) {
            return 'Права участников';
        },
        'receive-summary-on-mail': function (params) {
            return 'Получать конспект встречи на почту';
        },
        'same-as-system': function (params) {
            return 'Как в системе';
        },
        security: function (params) {
            return 'Безопасность';
        },
        'show-mic-or-camera-on': function (params) {
            return 'Показать, включена ли камера и микрофон';
        },
        'show-my-video': function (params) {
            return 'Показывать для меня моё видео на встрече';
        },
        sound: function (params) {
            return 'Звук';
        },
        'sound-output': function (params) {
            return 'Вывод звука';
        },
        support: function (params) {
            return 'Поддержка';
        },
        theme: function (params) {
            return 'Тема оформления';
        },
        'theme-dark-flow': function (params) {
            return 'Темный поток';
        },
        'theme-flow': function (params) {
            return 'Поток';
        },
        'theme-grass': function (params) {
            return 'Трава';
        },
        'theme-new-year': function (params) {
            return 'Новый год';
        },
        'theme-title': function (params) {
            return 'Тема оформления Яндекс 360';
        },
        title: function (params) {
            return 'Настройки';
        },
        'unsupported-camera-change-message': function (params) {
            return (
                'В Mozilla Firefox нельзя поменять настройки камеры. Попробуйте ' +
                '<x-link-telemost>' +
                'Телемост для компьютера' +
                '</x-link-telemost>' +
                ' или ' +
                '<x-link-yabro>' +
                'Яндекс Браузер' +
                '</x-link-yabro>' +
                '.'
            );
        },
        'unsupported-microphone-change-message': function (params) {
            return (
                'В Mozilla Firefox нельзя поменять настройки звука.\nПопробуйте ' +
                '<x-link-telemost>' +
                'Телемост для компьютера' +
                '</x-link-telemost>' +
                ' или ' +
                '<x-link-yabro>' +
                'Яндекс Браузер' +
                '</x-link-yabro>' +
                '.'
            );
        },
        'virtual-background': function (params) {
            return 'Виртуальный фон';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['share-screen'] = {
        'full-screen': function (params) {
            return 'Весь экран';
        },
        'please-wait-long': function (params) {
            return 'Пожалуйста, подождите, скоро все будет';
        },
        screen: function (params) {
            return 'Экран';
        },
        'self-starts-demonstration': function (params) {
            return 'Вы запускаете демонстрацию экрана';
        },
        'start-demonstration': function (params) {
            return 'Начать демонстрацию экрана';
        },
        'start-sharing': function (params) {
            return 'Начать трансляцию экрана';
        },
        'stop-demonstration': function (params) {
            return 'Закончить демонстрацию экрана';
        },
        'stop-demonstration-2': function (params) {
            return 'Остановить демонстрацию';
        },
        'user-starts-demonstration': function (params) {
            return params['name'] + ' запускает демонстрацию экрана';
        },
        window: function (params) {
            return 'Окно программы';
        },
        'your-screen-shared': function (params) {
            return 'Ваш экран видят другие участники встречи';
        },
        'zoom-in': function (params) {
            return 'Приблизить';
        },
        'zoom-out': function (params) {
            return 'Отдалить';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['slot-plugins'] = {
        empty: function (params) {
            return 'Нет доступных плагинов';
        },
        'load-error': function (params) {
            return 'Не удалось загрузить плагин';
        },
        loading: function (params) {
            return 'Загрузка плагинов';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['statuses'] = {
        'admins-will-receive-summary': function (params) {
            return 'Конспект встречи придёт на почту соорганизаторам';
        },
        'admins-will-receive-summary-update-error': function (params) {
            return 'Не удалось изменить настройки — конспект придёт соорганизаторам';
        },
        'broadcast-create-error': function (params) {
            return 'Не удалось создать трансляцию';
        },
        'broadcast-end-error': function (params) {
            return 'Не удалось завершить трансляцию';
        },
        'broadcast-start-error': function (params) {
            return 'Не удалось начать трансляцию';
        },
        'broadcast-stop-error': function (params) {
            return 'Не удалось приостановить трансляцию';
        },
        'camera-error': function (params) {
            return 'Включить видео не удалось.\nКамера не работает или используется другим приложением.';
        },
        'camera-permission-denied': function (params) {
            return 'Включить видео не удалось.\nНет доступа к камере.';
        },
        'chat-create-error': function (params) {
            return 'Не удалось создать чат видеовстречи,' + params['spacebreak'] + 'попробуйте позже';
        },
        'chat-open-error': function (params) {
            return 'Не удалось открыть чат видеовстречи,' + params['spacebreak'] + 'попробуйте позже';
        },
        'connection-established': function (params) {
            return 'Вы снова на встрече';
        },
        'connection-lost': function (params) {
            return 'Соединение потеряно. Попробуйте подключиться снова';
        },
        'feedback-sended': function (params) {
            return 'Спасибо, что помогаете нам становиться лучше';
        },
        'how-to-do-it': function (params) {
            return 'Как это сделать?';
        },
        'how-to-enable-device': function (params) {
            return 'Как выдать доступ?';
        },
        joining: function (params) {
            return 'Идет подключение';
        },
        'link-already-copied': function (params) {
            return 'Ссылка на встречу уже скопирована \n в буфер обмена';
        },
        'link-copied': function (params) {
            return 'Ссылка скопирована в буфер обмена';
        },
        'microphone-error': function (params) {
            return 'Включить микрофон не удалось.\nОн не работает или используется другим приложением.';
        },
        'microphone-permission-denied': function (params) {
            return 'Включить микрофон не удалось.\nНет доступа к микрофону.';
        },
        'modal-device-error-text-audioinput': function (params) {
            return 'Проверьте, что он подключён и выбран в настройках Телемоста';
        },
        'modal-device-error-text-audioinput-busy': function (params) {
            return 'Закройте его, чтобы включить звук, или выберите другой микрофон в настройках';
        },
        'modal-device-error-text-audioinput-denied-by-system': function (params) {
            return 'Разрешите доступ к микрофону в настройках операционной системы, а затем в адресной строке браузера';
        },
        'modal-device-error-text-audioinput-denied-by-user': function (params) {
            return 'Разрешите доступ к микрофону';
        },
        'modal-device-error-text-audioinput-denied-by-user-alternative': function (params) {
            return 'В адресной строке браузера нажмите значок микрофона, а затем «Разрешить»';
        },
        'modal-device-error-text-not-ready': function (params) {
            return 'Выберите другое устройство в настройках Телемоста или перезагрузите компьютер и подключитесь ещё раз';
        },
        'modal-device-error-text-request': function (params) {
            return 'Проверьте, что они подключены и выбраны в настройках Телемоста, не используются другими приложениями и к ним выдан доступ';
        },
        'modal-device-error-text-request-alternative': function (params) {
            return 'Проверьте, что камера подключена и выбрана в настройках Телемоста, не используется другими приложениями. В адресной строке браузера нажмите значок камеры, а затем «Разрешить»';
        },
        'modal-device-error-text-videoinput': function (params) {
            return 'Проверьте, что камера подключена и выбрана в настройках Телемоста';
        },
        'modal-device-error-text-videoinput-applying': function (params) {
            return 'Проверьте, что камера подключена и выбрана в настройках Телемоста, не используется другими приложениями и к ней выдан доступ';
        },
        'modal-device-error-text-videoinput-applying-alternative': function (params) {
            return 'Проверьте, что камера подключена и выбрана в настройках Телемоста, не используется другими приложениями. В адресной строке браузера нажмите значок камеры, а затем «Разрешить»';
        },
        'modal-device-error-text-videoinput-busy': function (params) {
            return 'Закройте его, чтобы включить видео, или выберите другую камеру в настройках';
        },
        'modal-device-error-text-videoinput-denied-by-system': function (params) {
            return 'Разрешите доступ к камере в настройках операционной системы, а затем в адресной строке браузера';
        },
        'modal-device-error-text-videoinput-denied-by-user': function (params) {
            return 'Разрешите доступ к камере';
        },
        'modal-device-error-text-videoinput-denied-by-user-alternative': function (params) {
            return 'В адресной строке браузера нажмите значок камеры, а затем «Разрешить»';
        },
        'modal-device-error-text-videoinput-overconstrained': function (params) {
            return 'Камера не поддерживает оптимальное разрешение. Смените её в настройках или отключите видео';
        },
        'modal-device-error-title-audioinput': function (params) {
            return 'Включить микрофон не удалось';
        },
        'modal-device-error-title-audioinput-busy': function (params) {
            return 'Микрофон используется другим приложением';
        },
        'modal-device-error-title-audioinput-sound': function (params) {
            return 'Включить звук не удалось';
        },
        'modal-device-error-title-not-ready': function (params) {
            return 'Включить видео или микрофон не удалось';
        },
        'modal-device-error-title-request': function (params) {
            return 'Включить видео или микрофон не удалось';
        },
        'modal-device-error-title-videoinput': function (params) {
            return 'Включить видео не удалось';
        },
        'modal-device-error-title-videoinput-busy': function (params) {
            return 'Камера используется другим приложением';
        },
        'modal-device-error-title-videoinput-overconstrained': function (params) {
            return 'Вас плохо видно';
        },
        'network-quality-bad': function (params) {
            return 'У вас плохая связь';
        },
        'network-quality-hide-video': function (params) {
            return 'Если скрыть видео участников, звук будет лучше';
        },
        'network-quality-show-video': function (params) {
            return 'Связь наладилась, можно вернуть видео участников';
        },
        'no-internet': function (params) {
            return 'Нет интернета';
        },
        'no-permission-to-close-room': function (params) {
            return 'Не удалось завершить — организатор запретил управлять встречей';
        },
        'notification-broadcast-access-level-organization': function (params) {
            return 'Трансляция только для сотрудников организации';
        },
        'notification-broadcast-access-level-public': function (params) {
            return 'Трансляция доступна внешним пользователям';
        },
        'notification-cloud-recording-in-progress': function (params) {
            return 'Встреча записывается на Яндекс Диск';
        },
        'notification-cloud-recording-start-failed': function (params) {
            return 'Не удалось начать запись на Яндекс Диск';
        },
        'notification-cloud-recording-start-failed-mobile': function (params) {
            return 'Не удалось начать запись';
        },
        'notification-cloud-recording-stop-failed': function (params) {
            return 'Не удалось остановить запись на Яндекс Диск';
        },
        'notification-cloud-recording-stop-failed-mobile': function (params) {
            return 'Не удалось остановить запись';
        },
        'notification-cloud-recording-was-stopped': function (params) {
            return 'Запись на Яндекс Диск остановлена';
        },
        'notification-conference-access-level-organization': function (params) {
            return 'Встреча только для сотрудников организации';
        },
        'notification-conference-access-level-public': function (params) {
            return 'Встреча доступна внешним пользователям';
        },
        'notification-conference-access-level-waiting-room-admins': function (params) {
            return 'Комната ожидания включена для всех';
        },
        'notification-conference-access-level-waiting-room-organization': function (params) {
            return 'Комната ожидания включена для внешних участников';
        },
        'notification-conference-access-level-waiting-room-public': function (params) {
            return 'Комната ожидания выключена';
        },
        'notification-noise-cancellation-disabled': function (params) {
            return 'Шумоподавление выключено';
        },
        'notification-noise-cancellation-enabled': function (params) {
            return 'Шумоподавление включено';
        },
        'notification-noise-cancellation-high': function (params) {
            return 'Включено сильное шумоподавление';
        },
        'notification-noise-cancellation-low': function (params) {
            return 'Включено слабое шумоподавление';
        },
        'notification-summarization-in-progress-for-external': function (params) {
            return 'Встреча записывается';
        },
        'notification-summarization-in-progress-v2': function (params) {
            return 'Встреча конспектируется';
        },
        'notification-summarization-no-permission-to-stop': function (params) {
            return 'Не удалось остановить — организатор запретил управлять конспектом';
        },
        'notification-summarization-start-failed-v2': function (params) {
            return 'Не удалось запустить конспектирование';
        },
        'notification-summarization-stop-failed-v2': function (params) {
            return 'Не удалось остановить конспектирование';
        },
        'notification-summarization-was-stopped': function (params) {
            return 'Встреча больше не конспектируется';
        },
        'open-settings': function (params) {
            return 'В настройки';
        },
        'organizer-revoked-camera-permission': function (params) {
            return 'Организатор запретил включать камеру';
        },
        'organizer-revoked-desktop-permission': function (params) {
            return 'Организатор запретил делиться экраном';
        },
        'organizer-revoked-micro-permission': function (params) {
            return 'Организатор запретил включать микрофон';
        },
        'organizer-revoked-summarization-permission': function (params) {
            return 'Организатор запретил конспектировать';
        },
        'participants-limit': function (params) {
            return 'Не удается подключиться к видеовстрече: достигнут лимит участников';
        },
        'participants-video-hidden': function (params) {
            return 'Видео участников скрыты';
        },
        'participants-video-visible': function (params) {
            return 'Видео участников вернулись';
        },
        'participants-will-receive-summary': function (params) {
            return 'Конспект встречи придёт на почту всем участникам';
        },
        'participants-will-receive-summary-update-error': function (params) {
            return 'Не удалось изменить настройки — конспект придёт всем участникам';
        },
        'permissions-extended-apply-error': function (params) {
            return 'Не удалось изменить права на встрече';
        },
        'permissions-extended-apply-success': function (params) {
            return 'Права на встрече изменены';
        },
        'permissions-extended-matrix-edit-revoked': function (params) {
            return 'Вы больше не можете менять права на встрече';
        },
        'please-unmute': function (params) {
            return 'Вас не слышно, включите микрофон';
        },
        reconnecting: function (params) {
            return 'Переподключаемся, что-то пошло не так';
        },
        'restoring-connection': function (params) {
            return 'Восстанавливаем соединение';
        },
        'room-was-closed': function (params) {
            return 'Организатор завершил встречу для всех';
        },
        'screen-sharing-access-message': function (params) {
            return 'Разрешите доступ к экрану в настройках браузера';
        },
        'screen-sharing-already-active': function (params) {
            return 'Демонстрация уже идет. ';
        },
        'screen-sharing-cancelled-or-denied-message': function (params) {
            return 'Демонстрация отменена, или у браузера нет доступа к экрану';
        },
        'screen-sharing-error-info-message': function (params) {
            return 'Чтобы начать новую, сначала завершите предыдущую.';
        },
        'screen-sharing-race-message': function (params) {
            return 'Другой пользователь начал трансляцию экрана одновременно с вами. Попробуйте запустить трансляцию экрана позднее';
        },
        'summarization-in-progress-admins-will-receive': function (params) {
            return 'Встреча конспектируется — итоги придут на почту соорганизаторам';
        },
        'summarization-in-progress-participants-will-receive': function (params) {
            return 'Встреча конспектируется — итоги придут на почту всем участникам';
        },
        'summarization-no-permission-to-start': function (params) {
            return 'Конспектирование может запустить соорганизатор';
        },
        'to-settings': function (params) {
            return 'К настройкам';
        },
        'turn-on': function (params) {
            return 'Включить';
        },
        'user-broadcasting': function (params) {
            return params['name'] + ' ведёт\nтрансляцию встречи';
        },
        'user-was-kicked': function (params) {
            return 'Вы были удалены со встречи';
        },
        'video-loading': function (params) {
            return 'Загружаем видео';
        },
        'waiting-room-admit-all-error': function (params) {
            return 'Не удалось впустить участников из комнаты ожидания';
        },
        'waiting-room-admit-error': function (params) {
            return 'Не удалось впустить участника';
        },
        'waiting-room-new-peer': function (params) {
            return params['displayName'] + ' в комнате ожидания';
        },
        'waiting-room-new-peers': function (params) {
            return 'Участники в комнате ожидания';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['summarization'] = {
        'feedback-chat-section-description': function (params) {
            return 'Пишите отзывы — они нужны, чтобы конспекты становились точнее. Узнавайте об обновлениях';
        },
        'feedback-chat-section-join': function (params) {
            return 'Вступить в чат';
        },
        'feedback-chat-section-title': function (params) {
            return 'Помогите нам сделать классно';
        },
        'feedback-content': function (params) {
            return 'Так искусственный интеллект учится быстрее';
        },
        'feedback-content-v2': function (params) {
            return 'Так Алиса Про учится быстрее';
        },
        'feedback-header': function (params) {
            return 'Спасибо за оценку';
        },
        'send-summary-to-participants': function (params) {
            return 'Отправить конспект всем участникам';
        },
        'start-dialog-content': function (params) {
            return 'Конспект придёт в чат встречи и на почту участникам из Яндекса, которые были на встрече, пока работал YandexGPT';
        },
        'start-dialog-content-v2': function (params) {
            return 'Соорганизаторы, которые будут в это время на встрече, получат конспект на почту';
        },
        'start-dialog-deny': function (params) {
            return 'Нет';
        },
        'start-dialog-submit': function (params) {
            return 'Да';
        },
        'start-dialog-title': function (params) {
            return 'Конспектировать встречу с YandexGPT?';
        },
        'start-dialog-title-v2': function (params) {
            return 'Конспектировать встречу?';
        },
        'stop-dialog-change-participants-permissions': function (params) {
            return 'Изменить права участников можно в ' + '<x-link-settings>' + 'настройках' + '</x-link-settings>';
        },
        'stop-dialog-content': function (params) {
            return 'Конспектирование встречи остановится у всех участников';
        },
        'stop-dialog-content-receive-by-mail': function (params) {
            return 'Конспект придёт на почту';
        },
        'stop-dialog-content-v2': function (params) {
            return 'Конспектирование остановится у всех. Конспект придёт на почту соорганизаторам';
        },
        'stop-dialog-content-v3': function (params) {
            return 'Конспектирование остановится у всех.';
        },
        'stop-dialog-content_admins_bsr': function (params) {
            return 'Конспект придёт на почту соорганизаторам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_admins_bsr_members_bsr': function (params) {
            return 'Конспект придёт на почту соорганизаторам и участникам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_admins_bsr_members_csr': function (params) {
            return '— Соорганизаторам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре\n— Участникам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_admins_bsr_members_sr': function (params) {
            return '— Соорганизаторам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре\n— Участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_admins_csr': function (params) {
            return 'Конспект придёт на почту соорганизаторам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_admins_csr_members_bsr': function (params) {
            return '— Соорганизаторам, приглашённым в Яндекс Календаре\n— Участникам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_admins_csr_members_csr': function (params) {
            return 'Конспект придёт на почту соорганизаторам и участникам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_admins_csr_members_sr': function (params) {
            return '— Соорганизаторам, приглашённым в Яндекс Календаре\n— Участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_admins_sr': function (params) {
            return 'Конспект придёт на почту соорганизаторам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_admins_sr_members_bsr': function (params) {
            return '— Соорганизаторам, которые были на встрече во время конспектирования\n— Участникам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_admins_sr_members_csr': function (params) {
            return '— Соорганизаторам, которые были на встрече во время конспектирования\n— Участникам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_admins_sr_members_sr': function (params) {
            return 'Конспект придёт на почту соорганизаторам и участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_members_bsr': function (params) {
            return '— Участникам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре, конспект придёт на почту\n— Организатору и соорганизаторам конспект не придёт';
        },
        'stop-dialog-content_members_csr': function (params) {
            return '— Участникам, приглашённым в Яндекс Календаре, конспект придёт на почту\n— Организатору и соорганизаторам конспект не придёт';
        },
        'stop-dialog-content_members_sr': function (params) {
            return '— Участникам, которые были на встрече во время конспектирования, конспект придёт на почту\n— Организатору и соорганизаторам конспект не придёт';
        },
        'stop-dialog-content_nobody-receive': function (params) {
            return 'Конспект не придёт никому. Обратитесь к администратору организации, чтобы поменять права организатора и соорганизаторов';
        },
        'stop-dialog-content_owner_csr': function (params) {
            return 'Конспект придёт на почту организатору';
        },
        'stop-dialog-content_owner_csr_admins_bsr': function (params) {
            return '— Организатору\n— Соорганизаторам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_bsr': function (params) {
            return 'Конспект придёт на почту всем, кто был на встрече во время конспектирования, и приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_csr': function (params) {
            return '— Всем приглашённым в Яндекс Календаре\n— Соорганизаторам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_sr': function (params) {
            return '— Организатору \n— Соорганизаторам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре\n— Участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_csr_admins_csr': function (params) {
            return 'Конспект придёт на почту организатору и соорганизаторам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_bsr': function (params) {
            return '— Всем приглашённым в Яндекс Календаре\n— Участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_csr': function (params) {
            return 'Конспект придёт на почту всем приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_sr': function (params) {
            return '— Организатору\n— Соорганизаторам, приглашённым в Яндекс Календаре\n— Участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_csr_admins_sr': function (params) {
            return '— Организатору\n— Соорганизаторам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_bsr': function (params) {
            return '— Организатору\n— Соорганизаторам, которые были на встрече во время конспектирования\n— Участникам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_csr': function (params) {
            return '— Организатору\n— Соорганизаторам, которые были на встрече во время конспектирования\n— Участникам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_sr': function (params) {
            return '— Организатору\n— Соорганизаторам и участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_csr_members_bsr': function (params) {
            return '— Организатору\n— Участникам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_members_csr': function (params) {
            return 'Конспект придёт на почту организатору и участникам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_csr_members_sr': function (params) {
            return '— Организатору\n— Участникам, которые были на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_sr': function (params) {
            return 'Конспект придёт на почту организатору, если он был на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_sr_admins_bsr': function (params) {
            return '— Организатору, если он был на встрече во время конспектирования\n— Соорганизаторам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_bsr': function (params) {
            return '— Всем, кто был на встрече во время конспектирования\n— Приглашённым в Яндекс Календаре соорганизаторам и участникам';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_csr': function (params) {
            return '— Тем, кто был на встрече во время конспектирования: организатору и соорганизаторам\n— Приглашённым в Яндекс Календаре соорганизаторам и участникам';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_sr': function (params) {
            return '— Всем, кто был на встрече во время конспектирования\n— Приглашённым в Яндекс Календаре соорганизаторам';
        },
        'stop-dialog-content_owner_sr_admins_csr': function (params) {
            return '— Организатору, если он был на встрече во время конспектирования\n— Соорганизаторам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_bsr': function (params) {
            return '— Тем, кто был на встрече во время конспектирования: организатору и участникам \n— Приглашённым в Яндекс Календаре соорганизаторам и участникам';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_csr': function (params) {
            return '— Организатору, если он был на встрече во время конспектирования\n— Соорганизаторам и участникам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_sr': function (params) {
            return '— Тем, кто был на встрече во время конспектирования: организатору и участникам \n— Приглашённым в Яндекс Календаре соорганизаторам';
        },
        'stop-dialog-content_owner_sr_admins_sr': function (params) {
            return 'Конспект придёт на почту тем, кто был на встрече во время конспектирования: организатору и соорганизаторам';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_bsr': function (params) {
            return '— Всем, кто был на встрече во время конспектирования\n— Приглашённым в Яндекс Календаре участникам';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_csr': function (params) {
            return '— Тем, кто был на встрече во время конспектирования: организатору и соорганизаторам\n— Приглашённым в Яндекс Календаре участникам';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_sr': function (params) {
            return 'Конспект придёт на почту всем, кто был на встрече во время конспектирования';
        },
        'stop-dialog-content_owner_sr_members_bsr': function (params) {
            return '— Организатору, если он был на встрече во время конспектирования\n— Участникам, которые были на встрече во время конспектирования или приглашены в Яндекс Календаре';
        },
        'stop-dialog-content_owner_sr_members_csr': function (params) {
            return '— Организатору, если был на встрече во время конспектирования\n— Участникам, приглашённым в Яндекс Календаре';
        },
        'stop-dialog-content_owner_sr_members_sr': function (params) {
            return 'Конспект придёт на почту тем, кто был на встрече во время конспектирования: организатору и участникам';
        },
        'stop-dialog-deny': function (params) {
            return 'Нет, продолжить';
        },
        'stop-dialog-deny-v2': function (params) {
            return 'Нет';
        },
        'stop-dialog-submit': function (params) {
            return 'Остановить';
        },
        'stop-dialog-submit-v2': function (params) {
            return 'Да';
        },
        'stop-dialog-title': function (params) {
            return 'Остановить конспектирование?';
        },
        'stop-dialog-title-v2': function (params) {
            return 'Остановить конспектирование?';
        },
        'welcome-dialog-content': function (params) {
            return 'Участники из Яндекса получат конспект на почту — внешним участникам он не придёт';
        },
        'welcome-dialog-content-v2': function (params) {
            return 'Конспектирование могут запускать соорганизаторы встречи — конспект и расшифровка придут им на почту';
        },
        'welcome-dialog-content-v3': function (params) {
            return 'Полная расшифровка, пересказ договорённостей и основных тем встречи будут в письме';
        },
        'welcome-dialog-submit': function (params) {
            return 'Отлично';
        },
        'welcome-dialog-title': function (params) {
            return 'YandexGPT сделает конспект встречи ';
        },
        'welcome-dialog-title-v2': function (params) {
            return 'Нейросеть сделает конспект встречи ';
        },
        'welcome-dialog-title-v3': function (params) {
            return 'Алиса Про сделает конспект встречи';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['telemessenger-placeholder'] = {
        'continue-in-browser': function (params) {
            return 'Продолжить в браузере';
        },
        'install-telemost': function (params) {
            return 'Скачать Телемост';
        },
        'install-telemost-motivation-text': function (params) {
            return 'Скачайте приложение, чтобы переписываться и созваниваться с видео';
        },
        'you-have-been-invited-to-telemost-chat': function (params) {
            return 'Вас пригласили в чат\nв Телемосте';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['toolbar'] = {
        'access-level-organization': function (params) {
            return 'Закрыть для внешних';
        },
        'access-level-public': function (params) {
            return 'Открыть для всех';
        },
        'broadcast-continue': function (params) {
            return 'Продолжить трансляцию';
        },
        'broadcast-continue-v2': function (params) {
            return 'Возобновить трансляцию';
        },
        'broadcast-copy-link': function (params) {
            return 'Ссылка для зрителей';
        },
        'broadcast-end': function (params) {
            return 'Завершить трансляцию';
        },
        'broadcast-end-confirm-modal-cancel': function (params) {
            return 'Отменить';
        },
        'broadcast-end-confirm-modal-confirm': function (params) {
            return 'Завершить';
        },
        'broadcast-end-confirm-modal-content': function (params) {
            return 'Зрители перестанут видеть встречу, а участники смогут продолжить общение';
        },
        'broadcast-end-confirm-modal-header': function (params) {
            return 'Завершить трансляцию?';
        },
        'broadcast-ending': function (params) {
            return 'Завершается...';
        },
        'broadcast-not-on-air': function (params) {
            return 'Не в эфире';
        },
        'broadcast-not-on-air-tooltip': function (params) {
            return 'Нажмите, чтобы начать трансляцию или скопировать ссылку для зрителей';
        },
        'broadcast-on-air': function (params) {
            return 'В эфире';
        },
        'broadcast-on-air-tooltip': function (params) {
            return 'Нажмите, чтобы приостановить трансляцию или скопировать ссылку для зрителей';
        },
        'broadcast-paused': function (params) {
            return 'Пауза';
        },
        'broadcast-paused-tooltip': function (params) {
            return 'Нажмите, чтобы продолжить трансляцию или скопировать ссылку для зрителей';
        },
        'broadcast-starting': function (params) {
            return 'Запускается...';
        },
        'broadcast-starting-tooltip': function (params) {
            return 'Трансляция запускается, это займёт около минуты';
        },
        'broadcast-viewers-count': function (params) {
            return (
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'зритель',
                    some: 'зрителя',
                    many: 'зрителей',
                })
            );
        },
        'chat-button-alt-title': function (params) {
            return 'Открыть чат';
        },
        'chat-button-close-alt-title': function (params) {
            return 'Закрыть чат';
        },
        'chat-button-title': function (params) {
            return 'Чат';
        },
        'close-toolbar': function (params) {
            return 'Закрыть раздел';
        },
        'cloud-recording-prepare': function (params) {
            return 'Подготовка к записи...';
        },
        'cloud-recording-start': function (params) {
            return 'Записать на Яндекс Диск';
        },
        'cloud-recording-stop': function (params) {
            return 'Остановить запись на Яндекс Диск';
        },
        'continue-broadcast': function (params) {
            return 'Продолжить трансляцию';
        },
        'create-broadcast': function (params) {
            return 'Создать трансляцию';
        },
        'end-call': function (params) {
            return 'Покинуть встречу';
        },
        'end-call-alt': function (params) {
            return 'Выйти из встречи';
        },
        'end-call-for-everyone': function (params) {
            return 'Завершить встречу для всех';
        },
        'gallery-view': function (params) {
            return 'Вид галереи';
        },
        'hand-down': function (params) {
            return 'Опустить руку';
        },
        'hand-up': function (params) {
            return 'Поднять руку';
        },
        'local-recording-start': function (params) {
            return 'Записать на компьютер';
        },
        'local-recording-stop': function (params) {
            return 'Остановить запись на компьютер';
        },
        'more-option-turn-off-camera': function (params) {
            return 'Отключить видео';
        },
        'more-option-turn-off-mic': function (params) {
            return 'Отключить микрофон';
        },
        'more-option-turn-on-camera': function (params) {
            return 'Включить видео';
        },
        'more-popup-alt-title': function (params) {
            return 'Ещё';
        },
        'more-popup-option-settings': function (params) {
            return 'Настройки';
        },
        'open-settings': function (params) {
            return 'Открыть настройки';
        },
        'organizer-revoked-camera-permission': function (params) {
            return 'Организатор запретил включать камеру';
        },
        'organizer-revoked-desktop-permission': function (params) {
            return 'Организатор запретил делиться экраном';
        },
        'organizer-revoked-micro-permission': function (params) {
            return 'Организатор запретил включать микрофон';
        },
        'organizer-revoked-summarization-permission': function (params) {
            return 'Организатор запретил запускать конспект';
        },
        'participants-button-title': function (params) {
            return 'Участники';
        },
        'plugins-button-title': function (params) {
            return 'Плагины';
        },
        'presenter-view': function (params) {
            return 'Вид докладчика';
        },
        'quit-call-confirm-modal-confirm': function (params) {
            return 'Выйти';
        },
        'quit-call-confirm-modal-content': function (params) {
            return 'Трансляция встречи завершится';
        },
        'quit-call-confirm-modal-header': function (params) {
            return 'Выйти из встречи?';
        },
        'recording-in-process': function (params) {
            return 'Запись';
        },
        'recording-place-cloud': function (params) {
            return 'Яндекс Диск';
        },
        'recording-place-local': function (params) {
            return 'Компьютер';
        },
        'recording-stop': function (params) {
            return 'Остановить';
        },
        'share-desktop-button-started-title': function (params) {
            return 'Идет демонстрация';
        },
        'share-desktop-button-stop-title': function (params) {
            return 'Остановить';
        },
        'share-desktop-button-title': function (params) {
            return 'Демонстрация';
        },
        'show-limitation-popup-description': function (params) {
            return 'Запишутся только первые 30 минут. Записать встречу целиком можно в программе для компьютера.';
        },
        'show-limitation-popup-download': function (params) {
            return 'Установить программу';
        },
        'start-broadcast': function (params) {
            return 'Начать трансляцию';
        },
        'stop-broadcast': function (params) {
            return 'Приостановить трансляцию';
        },
        'summarization-mail-for-admins': function (params) {
            return 'Конспект будет у соорганизаторов';
        },
        'summarization-mail-for-participants': function (params) {
            return 'Конспект будет на почте';
        },
        'summarization-no-permission-to-start': function (params) {
            return 'Конспектирование может запустить соорганизатор';
        },
        'summarization-prepare': function (params) {
            return 'Конспектирование запускается...';
        },
        'summarization-running': function (params) {
            return 'Идёт конспект';
        },
        'summarization-start': function (params) {
            return 'Конспектировать с YandexGPT';
        },
        'summarization-start-v2': function (params) {
            return 'Конспектировать с Алисой Про';
        },
        'summarization-starting': function (params) {
            return 'Запускается...';
        },
        'summarization-starting-extended': function (params) {
            return 'Конспектирование запускается...';
        },
        'summarization-stop': function (params) {
            return 'Не конспектировать дальше';
        },
        'summarization-stop-extended': function (params) {
            return 'Не конспектировать дальше';
        },
        'summarization-stop-v2': function (params) {
            return 'Остановить';
        },
        'turn-off-camera': function (params) {
            return 'Выключить камеру';
        },
        'turn-off-mic': function (params) {
            return 'Выключить микрофон';
        },
        'turn-on-camera': function (params) {
            return 'Включить камеру';
        },
        'turn-on-mic': function (params) {
            return 'Включить микрофон';
        },
    };

    if (module && module.exports) {
        module.exports = i18n;
    } else {
        window.i18n = window.i18n || {};
        window.i18n['ru'] = i18n;
    }
})();
